import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})

export class CityesService {

	Zone = [
		'NORTE',
		'SUR',
		'ORIENTE', 
		'OCCIDENTE',
		'NOR-ORIENTE',
		'NOR-OCCIDENTE',
		'SUR-ORIENTE',
		'SUR-OCCIDENTE'
	]


	DepsAndCityes = [

		{
			'id': 0,
			'departamento': 'Amazonas',
			'ciudades': [
				{ name: 'Leticia', },
				{ name: 'Puerto Nari\u00f1o' },
			]
		},
		{
			'id': 1,
			'departamento': 'Antioquia',
			'ciudades': [
				{ name: 'Abejorral', },
				{ name: 'Abriaqu\u00ed', },
				{ name: 'Alejandr\u00eda', },
				{ name: 'Amag\u00e1', },
				{ name: 'Amalfi', },
				{ name: 'Andes', },
				{ name: 'Angel\u00f3polis', },
				{ name: 'Angostura', },
				{ name: 'Anor\u00ed', },
				{ name: 'Anz\u00e1', },
				{ name: 'Apartad\u00f3', },
				{ name: 'Arboletes', },
				{ name: 'Argelia', },
				{ name: 'Armenia', },
				{ name: 'Barbosa', },
				{ name: 'Bello', },
				{ name: 'Belmira', },
				{ name: 'Betania', },
				{ name: 'Betulia', },
				{ name: 'Brice\u00f1o', },
				{ name: 'Buritic\u00e1', },
				{ name: 'C\u00e1ceres', },
				{ name: 'Caicedo', },
				{ name: 'Caldas', },
				{ name: 'Campamento', },
				{ name: 'Ca\u00f1asgordas', },
				{ name: 'Caracol\u00ed', },
				{ name: 'Caramanta', },
				{ name: 'Carepa', },
				{ name: 'Carolina del Pr\u00edncipe', },
				{ name: 'Caucasia', },
				{ name: 'Chigorod\u00f3', },
				{ name: 'Cisneros', },
				{ name: 'Ciudad Bol\u00edvar', },
				{ name: 'Cocorn\u00e1', },
				{ name: 'Concepci\u00f3n', },
				{ name: 'Concordia', },
				{ name: 'Copacabana', },
				{ name: 'Dabeiba', },
				{ name: 'Donmat\u00edas', },
				{ name: 'Eb\u00e9jico', },
				{ name: 'El Bagre', },
				{ name: 'El Carmen de Viboral', },
				{ name: 'El Pe\u00f1ol', },
				{ name: 'El Retiro', },
				{ name: 'El Santuario', },
				{ name: 'Entrerr\u00edos', },
				{ name: 'Envigado', },
				{ name: 'Fredonia', },
				{ name: 'Frontino', },
				{ name: 'Giraldo', },
				{ name: 'Girardota', },
				{ name: 'G\u00f3mez Plata', },
				{ name: 'Granada', },
				{ name: 'Guadalupe', },
				{ name: 'Guarne', },
				{ name: 'Guatap\u00e9', },
				{ name: 'Heliconia', },
				{ name: 'Hispania', },
				{ name: 'Itag\u00fc\u00ed', },
				{ name: 'Ituango', },
				{ name: 'Jard\u00edn', },
				{ name: 'Jeric\u00f3', },
				{ name: 'La Ceja', },
				{ name: 'La Estrella', },
				{ name: 'La Pintada', },
				{ name: 'La Uni\u00f3n', },
				{ name: 'Liborina', },
				{ name: 'Maceo', },
				{ name: 'Marinilla', },
				{
					name: 'Medell\u00edn',
					barrios: [
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'Aldea Pablo VI'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'Carpinelo'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'El Compromiso'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'Granizal'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'La Avanzada'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'La Esperanza N.º 2'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'Moscú N.º 2'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'Popular N.º 1'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'Popular N.º 2'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'Santo Domingo Savio N.º 1'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'Santo Domingo Savio N.º 2'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'San Pablo'
						},
						{
							comuna: 'Comuna 1 - Popular',
							barrio: 'Villa Guadalupe'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'Santa Cruz'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'La Isla'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'El Playón de Los Comuneros'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'Pablo VI'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'La Frontera'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'La Francia'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'Andalucía'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'Villa del Socorro'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'Villa Niza'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'Moscú N.º 1'
						},
						{
							comuna: 'Comuna 2 - Santa Cruz',
							barrio: 'La Rosa'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'La Salle'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'Las Granjas'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'Campo Valdés N.º 2'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'Santa Inés'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'El Raizal'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'El Pomar'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'Manrique Central N.º 2'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'Manrique Oriental'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'Versalles N.º 1'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'Versalles N.º 2'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'La Cruz'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'La Honda'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'Oriente'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'Maria Cano - Carambola'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'San José La Cima N.º 1'
						},
						{
							comuna: 'Comuna 3 - Manrique',
							barrio: 'San José La Cima N.º 2'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Aranjuez'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Berlín'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'San Isidro'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Palermo'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Bermejal - Los Álamos'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Moravia'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Sevilla'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'San Pedro'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Manrique Central N.º 1'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Campo Valdés N.º 1'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Las Esmeraldas'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'La Piñuela'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Brasilia'
						},
						{
							comuna: 'Comuna 4 - Aranjuez',
							barrio: 'Miranda'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Castilla'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Toscana'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Héctor Abad Gómez'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Las Brisas'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Florencia'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Tejelo'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Boyacá'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Belalcázar'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Girardot'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Tricentenario'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Francisco Antonio Zea'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Alfonso López'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'Caribe'
						},
						{
							comuna: 'Comuna 5 - Castilla',
							barrio: 'El Progreso'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'Doce de Octubre N.º 1'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'Doce de Octubre N.º 2'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'Santander'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'Pedregal'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'La Esperanza'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'San Martín de Porres'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'Kennedy'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'Picacho'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'Picachito'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'Mirador del Doce'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'El Progreso N.º 2'
						},
						{
							comuna: 'Comuna 6 - Doce de Octubre',
							barrio: 'El Triunfo'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Robledo'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'El Volador'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'San Germán'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Barrio Facultad de Minas'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'La Pilarica'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Bosques de San Pablo'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Altamira'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Córdoba'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'López de Mesa'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'El Diamante'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Aures N.º 1'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Aures N.º 2'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Bello Horizonte'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Villa Flora'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Palenque'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Cucaracho'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Fuente Clara'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Santa Margarita'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Olaya Herrera'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Pajarito'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Monteclaro'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'Villa de La Iguaná'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'La Cuchilla'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'La Aurora'
						},
						{
							comuna: 'Comuna 7 - Robledo',
							barrio: 'La Campiña'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Villa Hermosa'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'La Mansión'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'San Miguel'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'La Ladera'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Golondrinas'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Batallón Girardot'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Llanaditas'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Los Mangos'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Sucre'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'El Pinal'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Trece de Noviembre'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'La Libertad'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Villatina'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'San Antonio'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Las Estancias'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Villa Turbay'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'La Sierra'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Villa Lilliam'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Esfuerzos de Paz N.º 1'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Esfuerzos de Paz N.º 2'
						},
						{
							comuna: 'Comuna 8 - Villa Hermosa',
							barrio: 'Enciso'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Buenos Aires'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Caicedo'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Juan Pablo II'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Ocho de Marzo'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Barrios de Jesús'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Bomboná N.º 2'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Los Cerros - El Vergel'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Alejandro Echavarría'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Miraflores'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Cataluña'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'La Milagrosa'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Gerona'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'El Salvador'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Loreto'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Asomadera N.º 1'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Asomadera N.º 2'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Asomadera N.º 3'
						},
						{
							comuna: 'Comuna 9 - Buenos Aires',
							barrio: 'Quinta Linda'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'La Candelaria'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Prado'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Jesús Nazareno'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'El Chagualo'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Estación Villa'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'San Benito'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Guayaquil'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Corazón de Jesús - Barrio Triste'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Calle Nueva'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Perpetuo Socorro'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Barrio Colón'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Las Palmas'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Bomboná N.º 1'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Boston'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Los Ángeles'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'Villa Nueva'
						},
						{
							comuna: 'Comuna 10 - La Candelaria',
							barrio: 'San Diego'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Los Conquistadores'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Laureles'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Carlos E. Restrepo'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Suramericana'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Naranjal'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'San Joaquín'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Bolivariana'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Las Acacias'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'La Castellana'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Lorena'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'El Velódromo'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Estadio'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Los Colores'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Cuarta Brigada'
						},
						{
							comuna: 'Comuna 11 - Laureles-Estadio',
							barrio: 'Florida Nueva'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'La América'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Ferrini'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Calasanz'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Los Pinos'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'La Floresta'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Santa Lucía'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'El Danubio'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Campo Alegre'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Santa Mónica'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Barrio Cristóbal'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Simón Bolívar'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Santa Teresita'
						},
						{
							comuna: 'Comuna 12 - La América',
							barrio: 'Calasanz Parte Alta'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'San Javier N.º 1'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'San Javier N.º 2'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'El Pesebre'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Blanquizal'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Santa Rosa de Lima'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Los Alcázares'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Metropolitano'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'La Pradera'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Juan XXIII'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'La Divisa'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Veinte de Julio'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Belencito'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Betania'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'El Corazón'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Las Independencias'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Nuevos Conquistadores'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'El Salado'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Eduardo Santos'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Peñitas'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Antonio Nariño'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'El Socorro'
						},
						{
							comuna: 'Comuna 13 - San Javier',
							barrio: 'Calasania'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Castropol'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Barrio Colombia'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Villa Carlota'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Lalinde'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Manila'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Las Lomas N.º 1'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Las Lomas N.º 2'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Altos del Poblado'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'El Tesoro'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Los Naranjos'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Los Balsos N.º 1'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Los Balsos N.º 2'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'San Lucas'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'El Diamante'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'El Castillo'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Alejandría'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'La Florida'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'El Poblado'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Astorga'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Patio Bonito'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'La Aguacatala'
						},
						{
							comuna: 'Comuna 14 - El Poblado',
							barrio: 'Santa María de Los Ángeles'
						},
						{
							comuna: 'Comuna 15 - Guayabal',
							barrio: 'Tenche'
						},
						{
							comuna: 'Comuna 15 - Guayabal',
							barrio: 'Trinidad'
						},
						{
							comuna: 'Comuna 15 - Guayabal',
							barrio: 'Santa Fe'
						},
						{
							comuna: 'Comuna 15 - Guayabal',
							barrio: 'Campo Amor'
						},
						{
							comuna: 'Comuna 15 - Guayabal',
							barrio: 'Cristo Rey'
						},
						{
							comuna: 'Comuna 15 - Guayabal',
							barrio: 'Guayabal'
						},
						{
							comuna: 'Comuna 15 - Guayabal',
							barrio: 'La Colina'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Belén'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Rodeo Alto'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Aguas Frías'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Cerro Nutibara'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Fátima'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Rosales'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Granada'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'San Bernardo'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Las Playas'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Diego Echavarria'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'La Mota'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'El Rincón'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'La Hondonada'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'La Loma de Los Bernal'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'La Gloria'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Altavista'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'La Palma'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Zafra'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Los Alpes'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Las Violetas'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Las Mercedes'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Nueva Villa de Aburrá'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'Miravalle'
						},
						{
							comuna: 'Comuna 16 - Belén',
							barrio: 'El Nogal - Los Almendros'
						}
					]
				},
				{ name: 'Montebello', },
				{ name: 'Murind\u00f3', },
				{ name: 'Mutat\u00e1', },
				{ name: 'Nari\u00f1o', },
				{ name: 'Nech\u00ed', },
				{ name: 'Necocl\u00ed', },
				{ name: 'Olaya', },
				{ name: 'Peque', },
				{ name: 'Pueblorrico', },
				{ name: 'Puerto Berr\u00edo', },
				{ name: 'Puerto Nare', },
				{ name: 'Puerto Triunfo', },
				{ name: 'Remedios', },
				{ name: 'Rionegro', },
				{ name: 'Sabanalarga', },
				{ name: 'Sabaneta', },
				{ name: 'Salgar', },
				{ name: 'San Andr\u00e9s de Cuerquia', },
				{ name: 'San Carlos', },
				{ name: 'San Francisco', },
				{ name: 'San Jer\u00f3nimo', },
				{ name: 'San Jos\u00e9 de la Monta\u00f1a', },
				{ name: 'San Juan de Urab\u00e1', },
				{ name: 'San Luis', },
				{ name: 'San Pedro de Urab\u00e1', },
				{ name: 'San Pedro de los Milagros', },
				{ name: 'San Rafael', },
				{ name: 'San Roque', },
				{ name: 'San Vicente', },
				{ name: 'Santa B\u00e1rbara', },
				{ name: 'Santa Fe de Antioquia', },
				{ name: 'Santa Rosa de Osos', },
				{ name: 'Santo Domingo', },
				{ name: 'Segovia', },
				{ name: 'Sons\u00f3n', },
				{ name: 'Sopetr\u00e1n', },
				{ name: 'T\u00e1mesis', },
				{ name: 'Taraz\u00e1', },
				{ name: 'Tarso', },
				{ name: 'Titirib\u00ed', },
				{ name: 'Toledo', },
				{ name: 'Turbo', },
				{ name: 'Uramita', },
				{ name: 'Urrao', },
				{ name: 'Valdivia', },
				{ name: 'Valpara\u00edso', },
				{ name: 'Vegach\u00ed', },
				{ name: 'Venecia', },
				{ name: 'Vig\u00eda del Fuerte', },
				{ name: 'Yal\u00ed', },
				{ name: 'Yarumal', },
				{ name: 'Yolomb\u00f3', },
				{ name: 'Yond\u00f3', },
				{ name: 'Zaragoza' },
			]
		},

		{
			'id': 2,
			'departamento': 'Arauca',
			'ciudades': [
				{ name: 'Arauca', },
				{ name: 'Arauquita', },
				{ name: 'Cravo Norte', },
				{ name: 'Fortul', },
				{ name: 'Puerto Rond\u00f3n', },
				{ name: 'Saravena', },
				{ name: 'Tame' },
			]
		},

		{
			'id': 3,
			'departamento': 'Atl\u00e1ntico',
			'ciudades': [
				{ name: 'Baranoa', },
				{ name: 'Barranquilla', },
				{ name: 'Campo de la Cruz', },
				{ name: 'Candelaria', },
				{ name: 'Galapa', },
				{ name: 'Juan de Acosta', },
				{ name: 'Luruaco', },
				{ name: 'Malambo', },
				{ name: 'Manat\u00ed', },
				{ name: 'Palmar de Varela', },
				{ name: 'Pioj\u00f3', },
				{ name: 'Polonuevo', },
				{ name: 'Ponedera', },
				{ name: 'Puerto Colombia', },
				{ name: 'Repel\u00f3n', },
				{ name: 'Sabanagrande', },
				{ name: 'Sabanalarga', },
				{ name: 'Santa Luc\u00eda', },
				{ name: 'Santo Tom\u00e1s', },
				{ name: 'Soledad', },
				{ name: 'Su\u00e1n', },
				{ name: 'Tubar\u00e1', },
				{ name: 'Usiacur\u00ed' },
			]
		},

		{
			'id': 4,
			'departamento': 'Bol\u00edvar',
			'ciudades': [
				{ name: 'Ach\u00ed', },
				{ name: 'Altos del Rosario', },
				{ name: 'Arenal', },
				{ name: 'Arjona', },
				{ name: 'Arroyohondo', },
				{ name: 'Barranco de Loba', },
				{ name: 'Brazuelo de Papayal', },
				{ name: 'Calamar', },
				{ name: 'Cantagallo', },
				{ name: 'Cartagena de Indias', },
				{ name: 'Cicuco', },
				{ name: 'Clemencia', },
				{ name: 'C\u00f3rdoba', },
				{ name: 'El Carmen de Bol\u00edvar', },
				{ name: 'El Guamo', },
				{ name: 'El Pe\u00f1\u00f3n', },
				{ name: 'Hatillo de Loba', },
				{ name: 'Magangu\u00e9', },
				{ name: 'Mahates', },
				{ name: 'Margarita', },
				{ name: 'Mar\u00eda la Baja', },
				{ name: 'Momp\u00f3s', },
				{ name: 'Montecristo', },
				{ name: 'Morales', },
				{ name: 'Noros\u00ed', },
				{ name: 'Pinillos', },
				{ name: 'Regidor', },
				{ name: 'R\u00edo Viejo', },
				{ name: 'San Crist\u00f3bal', },
				{ name: 'San Estanislao', },
				{ name: 'San Fernando', },
				{ name: 'San Jacinto del Cauca', },
				{ name: 'San Jacinto', },
				{ name: 'San Juan Nepomuceno', },
				{ name: 'San Mart\u00edn de Loba', },
				{ name: 'San Pablo', },
				{ name: 'Santa Catalina', },
				{ name: 'Santa Rosa', },
				{ name: 'Santa Rosa del Sur', },
				{ name: 'Simit\u00ed', },
				{ name: 'Soplaviento', },
				{ name: 'Talaigua Nuevo', },
				{ name: 'Tiquisio', },
				{ name: 'Turbaco', },
				{ name: 'Turban\u00e1', },
				{ name: 'Villanueva', },
				{ name: 'Zambrano' },
			]
		},

		{
			'id': 5,
			'departamento': 'Boyac\u00e1',
			'ciudades': [
				{ name: 'Almeida', },
				{ name: 'Aquitania', },
				{ name: 'Arcabuco', },
				{ name: 'Bel\u00e9n', },
				{ name: 'Berbeo', },
				{ name: 'Bet\u00e9itiva', },
				{ name: 'Boavita', },
				{ name: 'Boyac\u00e1', },
				{ name: 'Brice\u00f1o', },
				{ name: 'Buenavista', },
				{ name: 'Busbanz\u00e1', },
				{ name: 'Caldas', },
				{ name: 'Campohermoso', },
				{ name: 'Cerinza', },
				{ name: 'Chinavita', },
				{ name: 'Chiquinquir\u00e1', },
				{ name: 'Ch\u00edquiza', },
				{ name: 'Chiscas', },
				{ name: 'Chita', },
				{ name: 'Chitaraque', },
				{ name: 'Chivat\u00e1', },
				{ name: 'Chivor', },
				{ name: 'Ci\u00e9nega', },
				{ name: 'C\u00f3mbita', },
				{ name: 'Coper', },
				{ name: 'Corrales', },
				{ name: 'Covarach\u00eda', },
				{ name: 'Cubar\u00e1', },
				{ name: 'Cucaita', },
				{ name: 'Cu\u00edtiva', },
				{ name: 'Duitama', },
				{ name: 'El Cocuy', },
				{ name: 'El Espino', },
				{ name: 'Firavitoba', },
				{ name: 'Floresta', },
				{ name: 'Gachantiv\u00e1', },
				{ name: 'G\u00e1meza', },
				{ name: 'Garagoa', },
				{ name: 'Guacamayas', },
				{ name: 'Guateque', },
				{ name: 'Guayat\u00e1', },
				{ name: 'G\u00fcic\u00e1n', },
				{ name: 'Iza', },
				{ name: 'Jenesano', },
				{ name: 'Jeric\u00f3', },
				{ name: 'La Capilla', },
				{ name: 'La Uvita', },
				{ name: 'La Victoria', },
				{ name: 'Labranzagrande', },
				{ name: 'Macanal', },
				{ name: 'Marip\u00ed', },
				{ name: 'Miraflores', },
				{ name: 'Mongua', },
				{ name: 'Mongu\u00ed', },
				{ name: 'Moniquir\u00e1', },
				{ name: 'Motavita', },
				{ name: 'Muzo', },
				{ name: 'Nobsa', },
				{ name: 'Nuevo Col\u00f3n', },
				{ name: 'Oicat\u00e1', },
				{ name: 'Otanche', },
				{ name: 'Pachavita', },
				{ name: 'P\u00e1ez', },
				{ name: 'Paipa', },
				{ name: 'Pajarito', },
				{ name: 'Panqueba', },
				{ name: 'Pauna', },
				{ name: 'Paya', },
				{ name: 'Paz del R\u00edo', },
				{ name: 'Pesca', },
				{ name: 'Pisba', },
				{ name: 'Puerto Boyac\u00e1', },
				{ name: 'Qu\u00edpama', },
				{ name: 'Ramiriqu\u00ed', },
				{ name: 'R\u00e1quira', },
				{ name: 'Rond\u00f3n', },
				{ name: 'Saboy\u00e1', },
				{ name: 'S\u00e1chica', },
				{ name: 'Samac\u00e1', },
				{ name: 'San Eduardo', },
				{ name: 'San Jos\u00e9 de Pare', },
				{ name: 'San Luis de Gaceno', },
				{ name: 'San Mateo', },
				{ name: 'San Miguel de Sema', },
				{ name: 'San Pablo de Borbur', },
				{ name: 'Santa Mar\u00eda', },
				{ name: 'Santa Rosa de Viterbo', },
				{ name: 'Santa Sof\u00eda', },
				{ name: 'Santana', },
				{ name: 'Sativanorte', },
				{ name: 'Sativasur', },
				{ name: 'Siachoque', },
				{ name: 'Soat\u00e1', },
				{ name: 'Socha', },
				{ name: 'Socot\u00e1', },
				{ name: 'Sogamoso', },
				{ name: 'Somondoco', },
				{ name: 'Sora', },
				{ name: 'Sorac\u00e1', },
				{ name: 'Sotaquir\u00e1', },
				{ name: 'Susac\u00f3n', },
				{ name: 'Sutamarch\u00e1n', },
				{ name: 'Sutatenza', },
				{ name: 'Tasco', },
				{ name: 'Tenza', },
				{ name: 'Tiban\u00e1', },
				{ name: 'Tibasosa', },
				{ name: 'Tinjac\u00e1', },
				{ name: 'Tipacoque', },
				{ name: 'Toca', },
				{ name: 'Tog\u00fc\u00ed', },
				{ name: 'T\u00f3paga', },
				{ name: 'Tota', },
				{ name: 'Tunja', },
				{ name: 'Tunungu\u00e1', },
				{ name: 'Turmequ\u00e9', },
				{ name: 'Tuta', },
				{ name: 'Tutaz\u00e1', },
				{ name: '\u00dambita', },
				{ name: 'Ventaquemada', },
				{ name: 'Villa de Leyva', },
				{ name: 'Viracach\u00e1', },
				{ name: 'Zetaquira' },
			]
		},

		{
			'id': 6,
			'departamento': 'Caldas',
			'ciudades': [
				{ name: 'Aguadas', },
				{ name: 'Anserma', },
				{ name: 'Aranzazu', },
				{ name: 'Belalc\u00e1zar', },
				{ name: 'Chinchin\u00e1', },
				{ name: 'Filadelfia', },
				{ name: 'La Dorada', },
				{ name: 'La Merced', },
				{ name: 'Manizales', },
				{ name: 'Manzanares', },
				{ name: 'Marmato', },
				{ name: 'Marquetalia', },
				{ name: 'Marulanda', },
				{ name: 'Neira', },
				{ name: 'Norcasia', },
				{ name: 'P\u00e1cora', },
				{ name: 'Palestina', },
				{ name: 'Pensilvania', },
				{ name: 'Riosucio', },
				{ name: 'Risaralda', },
				{ name: 'Salamina', },
				{ name: 'Saman\u00e1', },
				{ name: 'San Jos\u00e9', },
				{ name: 'Sup\u00eda', },
				{ name: 'Victoria', },
				{ name: 'Villamar\u00eda', },
				{ name: 'Viterbo' },
			]
		},

		{
			'id': 7,
			'departamento': 'Caquet\u00e1',
			'ciudades': [
				{ name: 'Albania', },
				{ name: 'Bel\u00e9n de los Andaqu\u00edes', },
				{ name: 'Cartagena del Chair\u00e1', },
				{ name: 'Curillo', },
				{ name: 'El Doncello', },
				{ name: 'El Paujil', },
				{ name: 'Florencia', },
				{ name: 'La Monta\u00f1ita', },
				{ name: 'Mil\u00e1n', },
				{ name: 'Morelia', },
				{ name: 'Puerto Rico', },
				{ name: 'San Jos\u00e9 del Fragua', },
				{ name: 'San Vicente del Cagu\u00e1n', },
				{ name: 'Solano', },
				{ name: 'Solita', },
				{ name: 'Valpara\u00edso' },
			]
		},

		{
			'id': 8,
			'departamento': 'Casanare',
			'ciudades': [
				{ name: 'Aguazul', },
				{ name: 'Ch\u00e1meza', },
				{ name: 'Hato Corozal', },
				{ name: 'La Salina', },
				{ name: 'Man\u00ed', },
				{ name: 'Monterrey', },
				{ name: 'Nunch\u00eda', },
				{ name: 'Orocu\u00e9', },
				{ name: 'Paz de Ariporo', },
				{ name: 'Pore', },
				{ name: 'Recetor', },
				{ name: 'Sabanalarga', },
				{ name: 'S\u00e1cama', },
				{ name: 'San Luis de Palenque', },
				{ name: 'T\u00e1mara', },
				{ name: 'Tauramena', },
				{ name: 'Trinidad', },
				{ name: 'Villanueva', },
				{ name: 'Yopal' },
			]
		},

		{
			'id': 9,
			'departamento': 'Cauca',
			'ciudades': [
				{ name: 'Almaguer', },
				{ name: 'Argelia', },
				{ name: 'Balboa', },
				{ name: 'Bol\u00edvar', },
				{ name: 'Buenos Aires', },
				{ name: 'Cajib\u00edo', },
				{ name: 'Caldono', },
				{ name: 'Caloto', },
				{ name: 'Corinto', },
				{ name: 'El Tambo', },
				{ name: 'Florencia', },
				{ name: 'Guachen\u00e9', },
				{ name: 'Guap\u00ed', },
				{ name: 'Inz\u00e1', },
				{ name: 'Jambal\u00f3', },
				{ name: 'La Sierra', },
				{ name: 'La Vega', },
				{ name: 'L\u00f3pez de Micay', },
				{ name: 'Mercaderes', },
				{ name: 'Miranda', },
				{ name: 'Morales', },
				{ name: 'Padilla', },
				{ name: 'P\u00e1ez', },
				{ name: 'Pat\u00eda', },
				{ name: 'Piamonte', },
				{ name: 'Piendam\u00f3', },
				{ name: 'Popay\u00e1n', },
				{ name: 'Puerto Tejada', },
				{ name: 'Purac\u00e9', },
				{ name: 'Rosas', },
				{ name: 'San Sebasti\u00e1n', },
				{ name: 'Santa Rosa', },
				{ name: 'Santander de Quilichao', },
				{ name: 'Silvia', },
				{ name: 'Sotar\u00e1', },
				{ name: 'Su\u00e1rez', },
				{ name: 'Sucre', },
				{ name: 'Timb\u00edo', },
				{ name: 'Timbiqu\u00ed', },
				{ name: 'Torib\u00edo', },
				{ name: 'Totor\u00f3', },
				{ name: 'Villa Rica' },
			]
		},

		{
			'id': 10,
			'departamento': 'Cesar',
			'ciudades': [
				{ name: 'Aguachica', },
				{ name: 'Agust\u00edn Codazzi', },
				{ name: 'Astrea', },
				{ name: 'Becerril', },
				{ name: 'Bosconia', },
				{ name: 'Chimichagua', },
				{ name: 'Chiriguan\u00e1', },
				{ name: 'Curuman\u00ed', },
				{ name: 'El Copey', },
				{ name: 'El Paso', },
				{ name: 'Gamarra', },
				{ name: 'Gonz\u00e1lez', },
				{ name: 'La Gloria (Cesar)', },
				{ name: 'La Jagua de Ibirico', },
				{ name: 'La Paz', },
				{ name: 'Manaure Balc\u00f3n del Cesar', },
				{ name: 'Pailitas', },
				{ name: 'Pelaya', },
				{ name: 'Pueblo Bello', },
				{ name: 'R\u00edo de Oro', },
				{ name: 'San Alberto', },
				{ name: 'San Diego', },
				{ name: 'San Mart\u00edn', },
				{ name: 'Tamalameque', },
				{ name: 'Valledupar' },
			]
		},

		{
			'id': 11,
			'departamento': 'Choc\u00f3',
			'ciudades': [
				{ name: 'Acand\u00ed', },
				{ name: 'Alto Baud\u00f3', },
				{ name: 'Bagad\u00f3', },
				{ name: 'Bah\u00eda Solano', },
				{ name: 'Bajo Baud\u00f3', },
				{ name: 'Bojay\u00e1', },
				{ name: 'Cant\u00f3n de San Pablo', },
				{ name: 'C\u00e9rtegui', },
				{ name: 'Condoto', },
				{ name: 'El Atrato', },
				{ name: 'El Carmen de Atrato', },
				{ name: 'El Carmen del Dari\u00e9n', },
				{ name: 'Istmina', },
				{ name: 'Jurad\u00f3', },
				{ name: 'Litoral de San Juan', },
				{ name: 'Llor\u00f3', },
				{ name: 'Medio Atrato', },
				{ name: 'Medio Baud\u00f3', },
				{ name: 'Medio San Juan', },
				{ name: 'N\u00f3vita', },
				{ name: 'Nuqu\u00ed', },
				{ name: 'Quibd\u00f3', },
				{ name: 'R\u00edo Ir\u00f3', },
				{ name: 'R\u00edo Quito', },
				{ name: 'Riosucio', },
				{ name: 'San Jos\u00e9 del Palmar', },
				{ name: 'Sip\u00ed', },
				{ name: 'Tad\u00f3', },
				{ name: 'Uni\u00f3n Panamericana', },
				{ name: 'Ungu\u00eda' },
			]
		},

		{
			'id': 12,
			'departamento': 'Cundinamarca',
			'ciudades': [
				{ name: 'Agua de Dios', },
				{ name: 'Alb\u00e1n', },
				{ name: 'Anapoima', },
				{ name: 'Anolaima', },
				{ name: 'Apulo', },
				{ name: 'Arbel\u00e1ez', },
				{ name: 'Beltr\u00e1n', },
				{ name: 'Bituima', },
				{ name: 'Bogot\u00e1', },
				{ name: 'Bojac\u00e1', },
				{ name: 'Cabrera', },
				{ name: 'Cachipay', },
				{ name: 'Cajic\u00e1', },
				{ name: 'Caparrap\u00ed', },
				{ name: 'C\u00e1queza', },
				{ name: 'Carmen de Carupa', },
				{ name: 'Chaguan\u00ed', },
				{ name: 'Ch\u00eda', },
				{ name: 'Chipaque', },
				{ name: 'Choach\u00ed', },
				{ name: 'Chocont\u00e1', },
				{ name: 'Cogua', },
				{ name: 'Cota', },
				{ name: 'Cucunub\u00e1', },
				{ name: 'El Colegio', },
				{ name: 'El Pe\u00f1\u00f3n', },
				{ name: 'El Rosal', },
				{ name: 'Facatativ\u00e1', },
				{ name: 'F\u00f3meque', },
				{ name: 'Fosca', },
				{ name: 'Funza', },
				{ name: 'F\u00faquene', },
				{ name: 'Fusagasug\u00e1', },
				{ name: 'Gachal\u00e1', },
				{ name: 'Gachancip\u00e1', },
				{ name: 'Gachet\u00e1', },
				{ name: 'Gama', },
				{ name: 'Girardot', },
				{ name: 'Granada', },
				{ name: 'Guachet\u00e1', },
				{ name: 'Guaduas', },
				{ name: 'Guasca', },
				{ name: 'Guataqu\u00ed', },
				{ name: 'Guatavita', },
				{ name: 'Guayabal de S\u00edquima', },
				{ name: 'Guayabetal', },
				{ name: 'Guti\u00e9rrez', },
				{ name: 'Jerusal\u00e9n', },
				{ name: 'Jun\u00edn', },
				{ name: 'La Calera', },
				{ name: 'La Mesa', },
				{ name: 'La Palma', },
				{ name: 'La Pe\u00f1a', },
				{ name: 'La Vega', },
				{ name: 'Lenguazaque', },
				{ name: 'Machet\u00e1', },
				{ name: 'Madrid', },
				{ name: 'Manta', },
				{ name: 'Medina', },
				{ name: 'Mosquera', },
				{ name: 'Nari\u00f1o', },
				{ name: 'Nemoc\u00f3n', },
				{ name: 'Nilo', },
				{ name: 'Nimaima', },
				{ name: 'Nocaima', },
				{ name: 'Pacho', },
				{ name: 'Paime', },
				{ name: 'Pandi', },
				{ name: 'Paratebueno', },
				{ name: 'Pasca', },
				{ name: 'Puerto Salgar', },
				{ name: 'Pul\u00ed', },
				{ name: 'Quebradanegra', },
				{ name: 'Quetame', },
				{ name: 'Quipile', },
				{ name: 'Ricaurte', },
				{ name: 'San Antonio del Tequendama', },
				{ name: 'San Bernardo', },
				{ name: 'San Cayetano', },
				{ name: 'San Francisco', },
				{ name: 'San Juan de Rioseco', },
				{ name: 'Sasaima', },
				{ name: 'Sesquil\u00e9', },
				{ name: 'Sibat\u00e9', },
				{ name: 'Silvania', },
				{ name: 'Simijaca', },
				{ name: 'Soacha', },
				{ name: 'Sop\u00f3', },
				{ name: 'Subachoque', },
				{ name: 'Suesca', },
				{ name: 'Supat\u00e1', },
				{ name: 'Susa', },
				{ name: 'Sutatausa', },
				{ name: 'Tabio', },
				{ name: 'Tausa', },
				{ name: 'Tena', },
				{ name: 'Tenjo', },
				{ name: 'Tibacuy', },
				{ name: 'Tibirita', },
				{ name: 'Tocaima', },
				{ name: 'Tocancip\u00e1', },
				{ name: 'Topaip\u00ed', },
				{ name: 'Ubal\u00e1', },
				{ name: 'Ubaque', },
				{ name: 'Ubat\u00e9', },
				{ name: 'Une', },
				{ name: '\u00datica', },
				{ name: 'Venecia', },
				{ name: 'Vergara', },
				{ name: 'Vian\u00ed', },
				{ name: 'Villag\u00f3mez', },
				{ name: 'Villapinz\u00f3n', },
				{ name: 'Villeta', },
				{ name: 'Viot\u00e1', },
				{ name: 'Yacop\u00ed', },
				{ name: 'Zipac\u00f3n', },
				{ name: 'Zipaquir\u00e1' },
			]
		},

		{
			'id': 13,
			'departamento': 'C\u00f3rdoba',
			'ciudades': [
				{ name: 'Ayapel', },
				{ name: 'Buenavista', },
				{ name: 'Canalete', },
				{ name: 'Ceret\u00e9', },
				{ name: 'Chim\u00e1', },
				{ name: 'Chin\u00fa', },
				{ name: 'Ci\u00e9naga de Oro', },
				{ name: 'Cotorra', },
				{ name: 'La Apartada', },
				{ name: 'Lorica', },
				{ name: 'Los C\u00f3rdobas', },
				{ name: 'Momil', },
				{ name: 'Montel\u00edbano', },
				{ name: 'Monter\u00eda', },
				{ name: 'Mo\u00f1itos', },
				{ name: 'Planeta Rica', },
				{ name: 'Pueblo Nuevo', },
				{ name: 'Puerto Escondido', },
				{ name: 'Puerto Libertador', },
				{ name: 'Pur\u00edsima', },
				{ name: 'Sahag\u00fan', },
				{ name: 'San Andr\u00e9s de Sotavento', },
				{ name: 'San Antero', },
				{ name: 'San Bernardo del Viento', },
				{ name: 'San Carlos', },
				{ name: 'San Jos\u00e9 de Ur\u00e9', },
				{ name: 'San Pelayo', },
				{ name: 'Tierralta', },
				{ name: 'Tuch\u00edn', },
				{ name: 'Valencia' },
			]
		},

		{
			'id': 14,
			'departamento': 'Guain\u00eda',
			'ciudades': [
				{ name: 'In\u00edrida' },
			]
		},

		{
			'id': 15,
			'departamento': 'Guaviare',
			'ciudades': [
				{ name: 'Calamar', },
				{ name: 'El Retorno', },
				{ name: 'Miraflores', },
				{ name: 'San Jos\u00e9 del Guaviare' },
			]
		},

		{
			'id': 16,
			'departamento': 'Huila',
			'ciudades': [
				{ name: 'Acevedo', },
				{ name: 'Agrado', },
				{ name: 'Aipe', },
				{ name: 'Algeciras', },
				{ name: 'Altamira', },
				{ name: 'Baraya', },
				{ name: 'Campoalegre', },
				{ name: 'Colombia', },
				{ name: 'El Pital', },
				{ name: 'El\u00edas', },
				{ name: 'Garz\u00f3n', },
				{ name: 'Gigante', },
				{ name: 'Guadalupe', },
				{ name: 'Hobo', },
				{ name: '\u00cdquira', },
				{ name: 'Isnos', },
				{ name: 'La Argentina', },
				{ name: 'La Plata', },
				{ name: 'N\u00e1taga', },
				{ name: 'Neiva', },
				{ name: 'Oporapa', },
				{ name: 'Paicol', },
				{ name: 'Palermo', },
				{ name: 'Palestina', },
				{ name: 'Pitalito', },
				{ name: 'Rivera', },
				{ name: 'Saladoblanco', },
				{ name: 'San Agust\u00edn', },
				{ name: 'Santa Mar\u00eda', },
				{ name: 'Suaza', },
				{ name: 'Tarqui', },
				{ name: 'Tello', },
				{ name: 'Teruel', },
				{ name: 'Tesalia', },
				{ name: 'Timan\u00e1', },
				{ name: 'Villavieja', },
				{ name: 'Yaguar\u00e1' },
			]
		},

		{
			'id': 17,
			'departamento': 'La Guajira',
			'ciudades': [
				{ name: 'Albania', },
				{ name: 'Barrancas', },
				{ name: 'Dibulla', },
				{ name: 'Distracci\u00f3n', },
				{ name: 'El Molino', },
				{ name: 'Fonseca', },
				{ name: 'Hatonuevo', },
				{ name: 'La Jagua del Pilar', },
				{ name: 'Maicao', },
				{ name: 'Manaure', },
				{ name: 'Riohacha', },
				{ name: 'San Juan del Cesar', },
				{ name: 'Uribia', },
				{ name: 'Urumita', },
				{ name: 'Villanueva' },
			]
		},

		{
			'id': 18,
			'departamento': 'Magdalena',
			'ciudades': [
				{ name: 'Algarrobo', },
				{ name: 'Aracataca', },
				{ name: 'Ariguan\u00ed', },
				{ name: 'Cerro de San Antonio', },
				{ name: 'Chibolo', },
				{ name: 'Chibolo', },
				{ name: 'Ci\u00e9naga', },
				{ name: 'Concordia', },
				{ name: 'El Banco', },
				{ name: 'El Pi\u00f1\u00f3n', },
				{ name: 'El Ret\u00e9n', },
				{ name: 'Fundaci\u00f3n', },
				{ name: 'Guamal', },
				{ name: 'Nueva Granada', },
				{ name: 'Pedraza', },
				{ name: 'Piji\u00f1o del Carmen', },
				{ name: 'Pivijay', },
				{ name: 'Plato', },
				{ name: 'Pueblo Viejo', },
				{ name: 'Remolino', },
				{ name: 'Sabanas de San \u00c1ngel', },
				{ name: 'Salamina', },
				{ name: 'San Sebasti\u00e1n de Buenavista', },
				{ name: 'San Zen\u00f3n', },
				{ name: 'Santa Ana', },
				{ name: 'Santa B\u00e1rbara de Pinto', },
				{ name: 'Santa Marta', },
				{ name: 'Sitionuevo', },
				{ name: 'Tenerife', },
				{ name: 'Zapay\u00e1n', },
				{ name: 'Zona Bananera' },
			]
		},

		{
			'id': 19,
			'departamento': 'Meta',
			'ciudades': [
				{ name: 'Acac\u00edas', },
				{ name: 'Barranca de Up\u00eda', },
				{ name: 'Cabuyaro', },
				{ name: 'Castilla la Nueva', },
				{ name: 'Cubarral', },
				{ name: 'Cumaral', },
				{ name: 'El Calvario', },
				{ name: 'El Castillo', },
				{ name: 'El Dorado', },
				{ name: 'Fuente de Oro', },
				{ name: 'Granada', },
				{ name: 'Guamal', },
				{ name: 'La Macarena', },
				{ name: 'La Uribe', },
				{ name: 'Lejan\u00edas', },
				{ name: 'Mapirip\u00e1n', },
				{ name: 'Mesetas', },
				{ name: 'Puerto Concordia', },
				{ name: 'Puerto Gait\u00e1n', },
				{ name: 'Puerto Lleras', },
				{ name: 'Puerto L\u00f3pez', },
				{ name: 'Puerto Rico', },
				{ name: 'Restrepo', },
				{ name: 'San Carlos de Guaroa', },
				{ name: 'San Juan de Arama', },
				{ name: 'San Juanito', },
				{ name: 'San Mart\u00edn', },
				{ name: 'Villavicencio', },
				{ name: 'Vista Hermosa' },
			]
		},

		{
			'id': 20,
			'departamento': 'Nari\u00f1o',
			'ciudades': [
				{ name: 'Aldana', },
				{ name: 'Ancuy\u00e1', },
				{ name: 'Arboleda', },
				{ name: 'Barbacoas', },
				{ name: 'Bel\u00e9n', },
				{ name: 'Buesaco', },
				{ name: 'Chachag\u00fc\u00ed', },
				{ name: 'Col\u00f3n', },
				{ name: 'Consac\u00e1', },
				{ name: 'Contadero', },
				{ name: 'C\u00f3rdoba', },
				{ name: 'Cuaspud', },
				{ name: 'Cumbal', },
				{ name: 'Cumbitara', },
				{ name: 'El Charco', },
				{ name: 'El Pe\u00f1ol', },
				{ name: 'El Rosario', },
				{ name: 'El Tabl\u00f3n', },
				{ name: 'El Tambo', },
				{ name: 'Francisco Pizarro', },
				{ name: 'Funes', },
				{ name: 'Guachucal', },
				{ name: 'Guaitarilla', },
				{ name: 'Gualmat\u00e1n', },
				{ name: 'Iles', },
				{ name: 'Imu\u00e9s', },
				{ name: 'Ipiales', },
				{ name: 'La Cruz', },
				{ name: 'La Florida', },
				{ name: 'La Llanada', },
				{ name: 'La Tola', },
				{ name: 'La Uni\u00f3n', },
				{ name: 'Leiva', },
				{ name: 'Linares', },
				{ name: 'Los Andes', },
				{ name: 'Mag\u00fc\u00ed Pay\u00e1n', },
				{ name: 'Mallama', },
				{ name: 'Mosquera', },
				{ name: 'Nari\u00f1o', },
				{ name: 'Olaya Herrera', },
				{ name: 'Ospina', },
				{ name: 'Pasto', },
				{ name: 'Policarpa', },
				{ name: 'Potos\u00ed', },
				{ name: 'Providencia', },
				{ name: 'Puerres', },
				{ name: 'Pupiales', },
				{ name: 'Ricaurte', },
				{ name: 'Roberto Pay\u00e1n', },
				{ name: 'Samaniego', },
				{ name: 'San Bernardo', },
				{ name: 'San Jos\u00e9 de Alb\u00e1n', },
				{ name: 'San Lorenzo', },
				{ name: 'San Pablo', },
				{ name: 'San Pedro de Cartago', },
				{ name: 'Sandon\u00e1', },
				{ name: 'Santa B\u00e1rbara', },
				{ name: 'Santacruz', },
				{ name: 'Sapuyes', },
				{ name: 'Taminango', },
				{ name: 'Tangua', },
				{ name: 'Tumaco', },
				{ name: 'T\u00faquerres', },
				{ name: 'Yacuanquer' },
			]
		},

		{
			'id': 21,
			'departamento': 'Norte de Santander',
			'ciudades': [
				{ name: '\u00c1brego', },
				{ name: 'Arboledas', },
				{ name: 'Bochalema', },
				{ name: 'Bucarasica', },
				{ name: 'C\u00e1chira', },
				{ name: 'C\u00e1cota', },
				{ name: 'Chin\u00e1cota', },
				{ name: 'Chitag\u00e1', },
				{ name: 'Convenci\u00f3n', },
				{ name: 'C\u00facuta', },
				{ name: 'Cucutilla', },
				{ name: 'Duran\u00eda', },
				{ name: 'El Carmen', },
				{ name: 'El Tarra', },
				{ name: 'El Zulia', },
				{ name: 'Gramalote', },
				{ name: 'Hacar\u00ed', },
				{ name: 'Herr\u00e1n', },
				{ name: 'La Esperanza', },
				{ name: 'La Playa de Bel\u00e9n', },
				{ name: 'Labateca', },
				{ name: 'Los Patios', },
				{ name: 'Lourdes', },
				{ name: 'Mutiscua', },
				{ name: 'Oca\u00f1a', },
				{ name: 'Pamplona', },
				{ name: 'Pamplonita', },
				{ name: 'Puerto Santander', },
				{ name: 'Ragonvalia', },
				{ name: 'Salazar de Las Palmas', },
				{ name: 'San Calixto', },
				{ name: 'San Cayetano', },
				{ name: 'Santiago', },
				{ name: 'Santo Domingo de Silos', },
				{ name: 'Sardinata', },
				{ name: 'Teorama', },
				{ name: 'Tib\u00fa', },
				{ name: 'Toledo', },
				{ name: 'Villa Caro', },
				{ name: 'Villa del Rosario' },
			]
		},

		{
			'id': 22,
			'departamento': 'Putumayo',
			'ciudades': [
				{ name: 'Col\u00f3n', },
				{ name: 'Mocoa', },
				{ name: 'Orito', },
				{ name: 'Puerto As\u00eds', },
				{ name: 'Puerto Caicedo', },
				{ name: 'Puerto Guzm\u00e1n', },
				{ name: 'Puerto Legu\u00edzamo', },
				{ name: 'San Francisco', },
				{ name: 'San Miguel', },
				{ name: 'Santiago', },
				{ name: 'Sibundoy', },
				{ name: 'Valle del Guamuez', },
				{ name: 'Villagarz\u00f3n' },
			]
		},

		{
			'id': 23,
			'departamento': 'Quind\u00edo',
			'ciudades': [
				{ name: 'Armenia', },
				{ name: 'Buenavista', },
				{ name: 'Calarc\u00e1', },
				{ name: 'Circasia', },
				{ name: 'C\u00f3rdoba', },
				{ name: 'Filandia', },
				{ name: 'G\u00e9nova', },
				{ name: 'La Tebaida', },
				{ name: 'Montenegro', },
				{ name: 'Pijao', },
				{ name: 'Quimbaya', },
				{ name: 'Salento' },
			]
		},

		{
			'id': 24,
			'departamento': 'Risaralda',
			'ciudades': [
				{ name: 'Ap\u00eda', },
				{ name: 'Balboa', },
				{ name: 'Bel\u00e9n de Umbr\u00eda', },
				{ name: 'Dosquebradas', },
				{ name: 'Gu\u00e1tica', },
				{ name: 'La Celia', },
				{ name: 'La Virginia', },
				{ name: 'Marsella', },
				{ name: 'Mistrat\u00f3', },
				{ name: 'Pereira', },
				{ name: 'Pueblo Rico', },
				{ name: 'Quinch\u00eda', },
				{ name: 'Santa Rosa de Cabal', },
				{ name: 'Santuario' },
			]
		},

		{
			'id': 25,
			'departamento': 'San Andr\u00e9s y Providencia',
			'ciudades': [
				{ name: 'Providencia y Santa Catalina Islas', },
				{ name: 'San Andr\u00e9s' },
			]
		},

		{
			'id': 26,
			'departamento': 'Santander',
			'ciudades': [
				{ name: 'Aguada', },
				{ name: 'Albania', },
				{ name: 'Aratoca', },
				{ name: 'Barbosa', },
				{ name: 'Barichara', },
				{ name: 'Barrancabermeja', },
				{ name: 'Betulia', },
				{ name: 'Bol\u00edvar', },
				{ name: 'Bucaramanga', },
				{ name: 'Cabrera', },
				{ name: 'California', },
				{ name: 'Capitanejo', },
				{ name: 'Carcas\u00ed', },
				{ name: 'Cepit\u00e1', },
				{ name: 'Cerrito', },
				{ name: 'Charal\u00e1', },
				{ name: 'Charta', },
				{ name: 'Chima', },
				{ name: 'Chipat\u00e1', },
				{ name: 'Cimitarra', },
				{ name: 'Concepci\u00f3n', },
				{ name: 'Confines', },
				{ name: 'Contrataci\u00f3n', },
				{ name: 'Coromoro', },
				{ name: 'Curit\u00ed', },
				{ name: 'El Carmen de Chucur\u00ed', },
				{ name: 'El Guacamayo', },
				{ name: 'El Pe\u00f1\u00f3n', },
				{ name: 'El Play\u00f3n', },
				{ name: 'El Socorro', },
				{ name: 'Encino', },
				{ name: 'Enciso', },
				{ name: 'Flori\u00e1n', },
				{ name: 'Floridablanca', },
				{ name: 'Gal\u00e1n', },
				{ name: 'G\u00e1mbita', },
				{ name: 'Gir\u00f3n', },
				{ name: 'Guaca', },
				{ name: 'Guadalupe', },
				{ name: 'Guapot\u00e1', },
				{ name: 'Guavat\u00e1', },
				{ name: 'G\u00fcepsa', },
				{ name: 'Hato', },
				{ name: 'Jes\u00fas Mar\u00eda', },
				{ name: 'Jord\u00e1n', },
				{ name: 'La Belleza', },
				{ name: 'La Paz', },
				{ name: 'Land\u00e1zuri', },
				{ name: 'Lebrija', },
				{ name: 'Los Santos', },
				{ name: 'Macaravita', },
				{ name: 'M\u00e1laga', },
				{ name: 'Matanza', },
				{ name: 'Mogotes', },
				{ name: 'Molagavita', },
				{ name: 'Ocamonte', },
				{ name: 'Oiba', },
				{ name: 'Onzaga', },
				{ name: 'Palmar', },
				{ name: 'Palmas del Socorro', },
				{ name: 'P\u00e1ramo', },
				{ name: 'Piedecuesta', },
				{ name: 'Pinchote', },
				{ name: 'Puente Nacional', },
				{ name: 'Puerto Parra', },
				{ name: 'Puerto Wilches', },
				{ name: 'Rionegro', },
				{ name: 'Sabana de Torres', },
				{ name: 'San Andr\u00e9s', },
				{ name: 'San Benito', },
				{ name: 'San Gil', },
				{ name: 'San Joaqu\u00edn', },
				{ name: 'San Jos\u00e9 de Miranda', },
				{ name: 'San Miguel', },
				{ name: 'San Vicente de Chucur\u00ed', },
				{ name: 'Santa B\u00e1rbara', },
				{ name: 'Santa Helena del Op\u00f3n', },
				{ name: 'Simacota', },
				{ name: 'Suaita', },
				{ name: 'Sucre', },
				{ name: 'Surat\u00e1', },
				{ name: 'Tona', },
				{ name: 'Valle de San Jos\u00e9', },
				{ name: 'V\u00e9lez', },
				{ name: 'Vetas', },
				{ name: 'Villanueva', },
				{ name: 'Zapatoca' },
			]
		},

		{
			'id': 27,
			'departamento': 'Sucre',
			'ciudades': [
				{ name: 'Buenavista', },
				{ name: 'Caimito', },
				{ name: 'Chal\u00e1n', },
				{ name: 'Colos\u00f3', },
				{ name: 'Corozal', },
				{ name: 'Cove\u00f1as', },
				{ name: 'El Roble', },
				{ name: 'Galeras', },
				{ name: 'Guaranda', },
				{ name: 'La Uni\u00f3n', },
				{ name: 'Los Palmitos', },
				{ name: 'Majagual', },
				{ name: 'Morroa', },
				{ name: 'Ovejas', },
				{ name: 'Sampu\u00e9s', },
				{ name: 'San Antonio de Palmito', },
				{ name: 'San Benito Abad', },
				{ name: 'San Juan de Betulia', },
				{ name: 'San Marcos', },
				{ name: 'San Onofre', },
				{ name: 'San Pedro', },
				{ name: 'Sinc\u00e9', },
				{ name: 'Sincelejo', },
				{ name: 'Sucre', },
				{ name: 'Tol\u00fa', },
				{ name: 'Tol\u00fa Viejo' },
			]
		},

		{
			'id': 28,
			'departamento': 'Tolima',
			'ciudades': [
				{ name: 'Alpujarra', },
				{ name: 'Alvarado', },
				{ name: 'Ambalema', },
				{ name: 'Anzo\u00e1tegui', },
				{ name: 'Armero', },
				{ name: 'Ataco', },
				{ name: 'Cajamarca', },
				{ name: 'Carmen de Apical\u00e1', },
				{ name: 'Casabianca', },
				{ name: 'Chaparral', },
				{ name: 'Coello', },
				{ name: 'Coyaima', },
				{ name: 'Cunday', },
				{ name: 'Dolores', },
				{ name: 'El Espinal', },
				{ name: 'Fal\u00e1n', },
				{ name: 'Flandes', },
				{ name: 'Fresno', },
				{ name: 'Guamo', },
				{ name: 'Herveo', },
				{ name: 'Honda', },
				{ name: 'Ibagu\u00e9', },
				{ name: 'Icononzo', },
				{ name: 'L\u00e9rida', },
				{ name: 'L\u00edbano', },
				{ name: 'Mariquita', },
				{ name: 'Melgar', },
				{ name: 'Murillo', },
				{ name: 'Natagaima', },
				{ name: 'Ortega', },
				{ name: 'Palocabildo', },
				{ name: 'Piedras', },
				{ name: 'Planadas', },
				{ name: 'Prado', },
				{ name: 'Purificaci\u00f3n', },
				{ name: 'Rioblanco', },
				{ name: 'Roncesvalles', },
				{ name: 'Rovira', },
				{ name: 'Salda\u00f1a', },
				{ name: 'San Antonio', },
				{ name: 'San Luis', },
				{ name: 'Santa Isabel', },
				{ name: 'Su\u00e1rez', },
				{ name: 'Valle de San Juan', },
				{ name: 'Venadillo', },
				{ name: 'Villahermosa', },
				{ name: 'Villarrica' },
			]
		},

		{
			'id': 29,
			'departamento': 'Valle del Cauca',
			'ciudades': [
				{ name: 'Alcal\u00e1', },
				{ name: 'Andaluc\u00eda', },
				{ name: 'Ansermanuevo', },
				{ name: 'Argelia', },
				{ name: 'Bol\u00edvar', },
				{ name: 'Buenaventura', },
				{ name: 'Buga', },
				{ name: 'Bugalagrande', },
				{ name: 'Caicedonia', },
				{
					name: 'Cali',
					barrios: [
						{
							comuna: 'COMUNA 1',
							barrio: 'Terrón Colorado'
						},
						{
							comuna: 'COMUNA 1',
							barrio: 'Vista Hermosa'
						},
						{
							comuna: 'COMUNA 1',
							barrio: 'Sector Patio Bonito'
						},
						{
							comuna: 'COMUNA 1',
							barrio: 'Aguacatal'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Santa Rita'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Santa Teresita'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Arboledas'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Normandía'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Juanambú'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Centenario'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Granada'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Versalles'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'San Vicente'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Santa Mónica '
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Prados del Norte'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'La Flora'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'La Campiña'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'La Paz'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'El Bosque'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Menga'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Ciudad Los Alamos'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Chipichape'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Brisas de los Alamos'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Urbanización La Merced'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Vipasa'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Urbanización La Flora'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Altos de Menga'
						},
						{
							comuna: 'COMUNA 2',
							barrio: 'Area en desarrollo - Parque del Amor'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'El Nacional'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'El Peñón'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'San Antonio'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'San Cayetano'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'Los Libertadores'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'San Juan Bosco'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'Santa Rosa'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'La Merced'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'San Pascual'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'El Calvario'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'San Pedro'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'San Nicolas'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'El Hoyo'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'El Piloto'
						},
						{
							comuna: 'COMUNA 3',
							barrio: 'Navarro - La Chanca'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Jorge Isaacs'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Santander'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Porvenir'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Las Delicias'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Manzanares'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Salomia'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Fátima'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Sultana - Berlín - San Francisco '
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Popular'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Ignacio Rengifo'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Guillermo Valencia'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'La Isla'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Marco Fidel Suárez'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Evaristo García'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'La Esmeralda'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Bolivariano'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Olaya Herrera'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Unidad Residencial Bueno Madrid'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Flora Industrial'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Calima'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'Industria de Licores'
						},
						{
							comuna: 'COMUNA 4',
							barrio: 'La Alianza'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'El Sena'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Los Andes'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Los Guayacanes'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Chiminangos Segunda Etapa'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Chiminangos Primera Etapa'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Metropolitano del Norte'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Los Parques - Barranquilla'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Villa del Sol'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Paseo de Los Almendros'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Los Andes B - La Riviera'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Torres de Comfandi'
						},
						{
							comuna: 'COMUNA 5',
							barrio: 'Villa del Prado - El Guabito'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'San Luís'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Jorge Eliecer Gaitán'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Paso del Comercio'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Los Alcázares'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Petecuy Primera Etapa'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Petecuy Segunda Etapa'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'La Rivera Primera Etapa'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Los Guaduales'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Petecuy Tercera Etapa'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Ciudadela Floralia'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Fonaviemcali'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'San Luís II'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Urbanización Calimio'
						},
						{
							comuna: 'COMUNA 6',
							barrio: 'Sector Puente del Comercio'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Alfonso López P. 1a. Etapa'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Alfonso López P. 2a. Etapa'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Alfonso López P. 3a. Etapa'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Puerto Nuevo'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Puerto Mallarino'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Urbanización El Angel del Hogar'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Siete de Agosto'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Los Pinos'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'San Marino'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Las Ceibas'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Base Aérea'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Parque de la Caña'
						},
						{
							comuna: 'COMUNA 7',
							barrio: 'Fepicol'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Primitivo Crespo'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Simón Bolívar'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Saavedra Galindo'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Uribe Uribe'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Santa Mónica Popular'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'La Floresta'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Benjamín Herrera'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Municipal'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Industrial'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'El Troncal'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Las Américas'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Atanasio Girardot'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Santa Fe'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Chapinero'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Villa Colombia'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'EL Trébol'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'La Base'
						},
						{
							comuna: 'COMUNA 8',
							barrio: 'Urbanización La Nueva Base'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Alameda'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Bretaña'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Junín'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Guayaquil'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Aranjuez'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Manuel María Buenaventura'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Santa Mónica Belalcázar'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Belalcázar'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Sucre'
						},
						{
							comuna: 'COMUNA 9',
							barrio: 'Barrio Obrero'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'El Dorado'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'El Guabal'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'La Libertad'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Santa Elena'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Las Acacias'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Santo Domingo'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Jorge Zawadsky'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Olímpico'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Cristóbal Colón'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'La Selva'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Barrio Departamental'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Pasoancho'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Panamericano'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Colseguros Andes'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'San Cristobal'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'Las Granjas'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'San Judas Tadeo I Etapa'
						},
						{
							comuna: 'COMUNA 10',
							barrio: 'San Judas Tadeo II Etapa'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'San Carlos'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'Maracaibo'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'La Independencia'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'La Esperanza'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'Urbanización Boyacá'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'El Jardín'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'La Fortaleza'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'El Recuerdo'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'Aguablanca'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'El Prado'
						},
						{
							comuna: 'COMUNA 11',
							barrio: '20 de Julio'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'Prados de Oriente'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'Los Sauces'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'Villa del Sur'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'José Holguín Garcés'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'León XIII'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'José María Cordoba'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'San Pedro Claver'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'Los Conquistadores'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'La Gran Colombia'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'San Benito'
						},
						{
							comuna: 'COMUNA 11',
							barrio: 'Primavera'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Villanueva'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Asturias'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Eduardo Santos'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Alfonso Barberena A.'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'El Paraiso'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Fenalco Kennedy'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Nueva Floresta'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Julio Rincón'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Doce de Octubre'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'El Rodeo'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Sindical'
						},
						{
							comuna: 'COMUNA 12',
							barrio: 'Bello Horizonte'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Ulpiano Lloreda'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'El Vergel'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'El Poblado I'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'El Poblado II'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Los Comuneros Segunda Etapa'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Ricardo Balcázar'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Omar Torrijos'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'El Diamante'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Lleras Restrepo'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Villa del Lago'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Los Robles'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Rodrigo Lara Bonilla'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Charco Azul'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Villablanca'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Calipso'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Yira Castro'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Lleras Restrepo II Etapa'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Marroquín III'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Los Lagos'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Sector Laguna del Pondaje'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'El Pondaje'
						},
						{
							comuna: 'COMUNA 13',
							barrio: 'Sector Asprosocial-Diamante'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'Alfonso Bonilla Aragón'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'Alirio Mora Beltrán'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'Manuela Beltrán'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'Las Orquídeas'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'José Manuel Marroquín Segunda Etapa'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'José Manuel Marroquín Primera Etapa'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'Puerta del Sol'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'Los Naranjos I'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'Promociones Populares B'
						},
						{
							comuna: 'COMUNA 14',
							barrio: 'Los Naranjos II'
						},
						{
							comuna: 'COMUNA 15',
							barrio: 'El Retiro'
						},
						{
							comuna: 'COMUNA 15',
							barrio: 'Comuneros I'
						},
						{
							comuna: 'COMUNA 15',
							barrio: 'Laureano Gómez'
						},
						{
							comuna: 'COMUNA 15',
							barrio: 'El Vallado'
						},
						{
							comuna: 'COMUNA 15',
							barrio: 'Ciudad Cordoba'
						},
						{
							comuna: 'COMUNA 15',
							barrio: 'Mojica'
						},
						{
							comuna: 'COMUNA 15',
							barrio: 'El Morichal'
						},
						{
							comuna: 'COMUNA 16',
							barrio: 'Mariano Ramos'
						},
						{
							comuna: 'COMUNA 16',
							barrio: 'República de Israel'
						},
						{
							comuna: 'COMUNA 16',
							barrio: 'Unión de Vivienda Popular'
						},
						{
							comuna: 'COMUNA 16',
							barrio: 'Antonio Nariño'
						},
						{
							comuna: 'COMUNA 16',
							barrio: 'Brisas del Limonar'
						},
						{
							comuna: 'COMUNA 16',
							barrio: 'Área desocupada'
						},
						{
							comuna: 'COMUNA 16',
							barrio: 'Ciudad 2000'
						},
						{
							comuna: 'COMUNA 16',
							barrio: 'La Alborada'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'La Playa'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Primero de Mayo'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Ciudadela Comfandi'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Ciudad Universitaria'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Caney'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Lili'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Santa Anita - La Selva'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'El Ingenio'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Mayapan - Las Vegas'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Las Quintas de Don Simón'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Ciudad Capri'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'La Hacienda'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Los Portales - Nuevo Rey'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Cañaverales - Los Samanes'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'El Limonar'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Bosques del Limonar'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'El Gran Limonar - Cataya'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'El Gran Limonar'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Unicentro Cali'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Ciudadela Pasoancho'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Prados del Limonar'
						},
						{
							comuna: 'COMUNA 17',
							barrio: 'Urbanización San Joaquin'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Buenos Aires'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Barrio Caldas'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Los Chorros'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Meléndez'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Los Farallones'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Francisco Eladio Ramirez'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Prados del Sur'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Horizontes'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Mario Correa Rengifo'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Lourdes'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Colinas del Sur'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Alférez Real'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Nápoles'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'El Jordán'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Cuarteles Napoles'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Sector Alto de Los Chorros'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Polvorines'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Sector Meléndez'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Sector Alto Jordán'
						},
						{
							comuna: 'COMUNA 18',
							barrio: 'Alto Nápoles '
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'El Refugio'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'La Cascada'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'El Lido'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Urbanización Tequendama'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Barrio Eucarístico'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'San Fernando Nuevo'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Urbanización Nueva Granada'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Santa Isabel'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Bellavista'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'San Fernando Viejo'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Miraflores'
						},
						{
							comuna: 'COMUNA 19',
							barrio: '3 de Julio'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'El Cedro'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Champagñat'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Urbanización Colseguros'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Los Cambulos'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'El Mortiñal'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Urbanización Militar'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Cuarto de Legua - Guadalupe'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Nueva Tequendama '
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Camino Real - Joaquín Borrero Sinisterra'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Camino Real - Los Fundadores'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Altos de Santa Isabel -  La Morelia'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Santa Barbara'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Tejares - Cristales'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Unidad Residencial Santiago de Cali'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Unidad Residencial El Coliseo'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Cañaveralejo - Seguros Patria'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Cañaveral'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Pampa Linda'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'Sector Cañaveralejo Guadalupe'
						},
						{
							comuna: 'COMUNA 19',
							barrio: 'U.D. Alberto Galindo -  Plaza de Toros'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'El Cortijo'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'Belisario Caicedo'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'Siloé'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'Lleras Camargo'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'Belén'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'Brisas de Mayo'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'Tierra Blanca'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'Pueblo Joven'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'Carabineros'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'Venezuela - Urbanización Cañaveralejo'
						},
						{
							comuna: 'COMUNA 20',
							barrio: 'La Sultana'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Pízamos I'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Pízamos II'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Calimio Desepaz'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'El Remanso'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Los Líderes'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Desepaz Invicali'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Compartir'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Ciudad Talanga'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Villamercedes I - Villa Luz - Las Garzas'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Pízamos III - Las Dalias'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Potrero Grande'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Ciudadela del Río'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Valle Grande'
						},
						{
							comuna: 'COMUNA 21',
							barrio: 'Planta de Tratamiento'
						},
						{
							comuna: 'COMUNA 22',
							barrio: 'Urbanización Ciudad Jardín'
						},
						{
							comuna: 'COMUNA 22',
							barrio: 'Parcelaciones Pance'
						},
						{
							comuna: 'COMUNA 22',
							barrio: 'Urbanización Río Lili'
						},
						{
							comuna: 'COMUNA 22',
							barrio: 'Ciudad Campestre'
						},
						{
							comuna: 'COMUNA 22',
							barrio: 'Club Campestre'
						}
					]
				},
				{ name: 'Calima', },
				{ name: 'Candelaria', },
				{ name: 'Cartago', },
				{ name: 'Dagua', },
				{ name: 'El \u00c1guila', },
				{ name: 'El Cairo', },
				{ name: 'El Cerrito', },
				{ name: 'El Dovio', },
				{ name: 'Florida', },
				{ name: 'Ginebra', },
				{ name: 'Guacar\u00ed', },
				{ name: 'Jamund\u00ed', },
				{ name: 'La Cumbre', },
				{ name: 'La Uni\u00f3n', },
				{ name: 'La Victoria', },
				{ name: 'Obando', },
				{ name: 'Palmira', },
				{ name: 'Pradera', },
				{ name: 'Restrepo', },
				{ name: 'Riofr\u00edo', },
				{ name: 'Roldanillo', },
				{ name: 'San Pedro', },
				{ name: 'Sevilla', },
				{ name: 'Toro', },
				{ name: 'Trujillo', },
				{ name: 'Tulu\u00e1', },
				{ name: 'Ulloa', },
				{ name: 'Versalles', },
				{ name: 'Vijes', },
				{ name: 'Yotoco', },
				{ name: 'Yumbo', },
				{ name: 'Zarzal' },
			]
		},

		{
			'id': 30,
			'departamento': 'Vaup\u00e9s',
			'ciudades': [
				{ name: 'Carur\u00fa', },
				{ name: 'Mit\u00fa', },
				{ name: 'Taraira' },
			]
		},

		{
			'id': 31,
			'departamento': 'Vichada',
			'ciudades': [
				{ name: 'Cumaribo', },
				{ name: 'La Primavera', },
				{ name: 'Puerto Carre\u00f1o', },
				{ name: 'Santa Rosal\u00eda' },
			]
		},

	]

	barrios = [
		{
			comuna: 'COMUNA 1',
			barrio: 'Terrón Colorado'
		},
		{
			comuna: 'COMUNA 1',
			barrio: 'Vista Hermosa'
		},
		{
			comuna: 'COMUNA 1',
			barrio: 'Sector Patio Bonito'
		},
		{
			comuna: 'COMUNA 1',
			barrio: 'Aguacatal'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Santa Rita'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Santa Teresita'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Arboledas'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Normandía'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Juanambú'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Centenario'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Granada'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Versalles'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'San Vicente'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Santa Mónica '
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Prados del Norte'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'La Flora'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'La Campiña'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'La Paz'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'El Bosque'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Menga'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Ciudad Los Alamos'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Chipichape'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Brisas de los Alamos'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Urbanización La Merced'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Vipasa'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Urbanización La Flora'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Altos de Menga'
		},
		{
			comuna: 'COMUNA 2',
			barrio: 'Area en desarrollo - Parque del Amor'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'El Nacional'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'El Peñón'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'San Antonio'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'San Cayetano'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'Los Libertadores'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'San Juan Bosco'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'Santa Rosa'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'La Merced'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'San Pascual'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'El Calvario'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'San Pedro'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'San Nicolas'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'El Hoyo'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'El Piloto'
		},
		{
			comuna: 'COMUNA 3',
			barrio: 'Navarro - La Chanca'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Jorge Isaacs'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Santander'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Porvenir'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Las Delicias'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Manzanares'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Salomia'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Fátima'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Sultana - Berlín - San Francisco '
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Popular'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Ignacio Rengifo'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Guillermo Valencia'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'La Isla'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Marco Fidel Suárez'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Evaristo García'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'La Esmeralda'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Bolivariano'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Olaya Herrera'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Unidad Residencial Bueno Madrid'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Flora Industrial'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Calima'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'Industria de Licores'
		},
		{
			comuna: 'COMUNA 4',
			barrio: 'La Alianza'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'El Sena'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Los Andes'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Los Guayacanes'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Chiminangos Segunda Etapa'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Chiminangos Primera Etapa'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Metropolitano del Norte'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Los Parques - Barranquilla'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Villa del Sol'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Paseo de Los Almendros'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Los Andes B - La Riviera'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Torres de Comfandi'
		},
		{
			comuna: 'COMUNA 5',
			barrio: 'Villa del Prado - El Guabito'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'San Luís'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Jorge Eliecer Gaitán'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Paso del Comercio'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Los Alcázares'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Petecuy Primera Etapa'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Petecuy Segunda Etapa'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'La Rivera Primera Etapa'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Los Guaduales'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Petecuy Tercera Etapa'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Ciudadela Floralia'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Fonaviemcali'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'San Luís II'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Urbanización Calimio'
		},
		{
			comuna: 'COMUNA 6',
			barrio: 'Sector Puente del Comercio'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Alfonso López P. 1a. Etapa'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Alfonso López P. 2a. Etapa'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Alfonso López P. 3a. Etapa'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Puerto Nuevo'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Puerto Mallarino'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Urbanización El Angel del Hogar'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Siete de Agosto'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Los Pinos'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'San Marino'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Las Ceibas'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Base Aérea'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Parque de la Caña'
		},
		{
			comuna: 'COMUNA 7',
			barrio: 'Fepicol'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Primitivo Crespo'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Simón Bolívar'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Saavedra Galindo'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Uribe Uribe'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Santa Mónica Popular'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'La Floresta'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Benjamín Herrera'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Municipal'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Industrial'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'El Troncal'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Las Américas'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Atanasio Girardot'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Santa Fe'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Chapinero'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Villa Colombia'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'EL Trébol'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'La Base'
		},
		{
			comuna: 'COMUNA 8',
			barrio: 'Urbanización La Nueva Base'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Alameda'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Bretaña'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Junín'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Guayaquil'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Aranjuez'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Manuel María Buenaventura'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Santa Mónica Belalcázar'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Belalcázar'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Sucre'
		},
		{
			comuna: 'COMUNA 9',
			barrio: 'Barrio Obrero'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'El Dorado'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'El Guabal'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'La Libertad'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Santa Elena'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Las Acacias'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Santo Domingo'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Jorge Zawadsky'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Olímpico'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Cristóbal Colón'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'La Selva'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Barrio Departamental'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Pasoancho'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Panamericano'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Colseguros Andes'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'San Cristobal'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'Las Granjas'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'San Judas Tadeo I Etapa'
		},
		{
			comuna: 'COMUNA 10',
			barrio: 'San Judas Tadeo II Etapa'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'San Carlos'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'Maracaibo'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'La Independencia'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'La Esperanza'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'Urbanización Boyacá'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'El Jardín'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'La Fortaleza'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'El Recuerdo'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'Aguablanca'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'El Prado'
		},
		{
			comuna: 'COMUNA 11',
			barrio: '20 de Julio'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'Prados de Oriente'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'Los Sauces'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'Villa del Sur'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'José Holguín Garcés'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'León XIII'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'José María Cordoba'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'San Pedro Claver'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'Los Conquistadores'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'La Gran Colombia'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'San Benito'
		},
		{
			comuna: 'COMUNA 11',
			barrio: 'Primavera'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Villanueva'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Asturias'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Eduardo Santos'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Alfonso Barberena A.'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'El Paraiso'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Fenalco Kennedy'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Nueva Floresta'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Julio Rincón'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Doce de Octubre'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'El Rodeo'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Sindical'
		},
		{
			comuna: 'COMUNA 12',
			barrio: 'Bello Horizonte'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Ulpiano Lloreda'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'El Vergel'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'El Poblado I'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'El Poblado II'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Los Comuneros Segunda Etapa'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Ricardo Balcázar'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Omar Torrijos'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'El Diamante'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Lleras Restrepo'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Villa del Lago'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Los Robles'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Rodrigo Lara Bonilla'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Charco Azul'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Villablanca'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Calipso'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Yira Castro'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Lleras Restrepo II Etapa'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Marroquín III'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Los Lagos'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Sector Laguna del Pondaje'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'El Pondaje'
		},
		{
			comuna: 'COMUNA 13',
			barrio: 'Sector Asprosocial-Diamante'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'Alfonso Bonilla Aragón'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'Alirio Mora Beltrán'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'Manuela Beltrán'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'Las Orquídeas'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'José Manuel Marroquín Segunda Etapa'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'José Manuel Marroquín Primera Etapa'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'Puerta del Sol'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'Los Naranjos I'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'Promociones Populares B'
		},
		{
			comuna: 'COMUNA 14',
			barrio: 'Los Naranjos II'
		},
		{
			comuna: 'COMUNA 15',
			barrio: 'El Retiro'
		},
		{
			comuna: 'COMUNA 15',
			barrio: 'Comuneros I'
		},
		{
			comuna: 'COMUNA 15',
			barrio: 'Laureano Gómez'
		},
		{
			comuna: 'COMUNA 15',
			barrio: 'El Vallado'
		},
		{
			comuna: 'COMUNA 15',
			barrio: 'Ciudad Cordoba'
		},
		{
			comuna: 'COMUNA 15',
			barrio: 'Mojica'
		},
		{
			comuna: 'COMUNA 15',
			barrio: 'El Morichal'
		},
		{
			comuna: 'COMUNA 16',
			barrio: 'Mariano Ramos'
		},
		{
			comuna: 'COMUNA 16',
			barrio: 'República de Israel'
		},
		{
			comuna: 'COMUNA 16',
			barrio: 'Unión de Vivienda Popular'
		},
		{
			comuna: 'COMUNA 16',
			barrio: 'Antonio Nariño'
		},
		{
			comuna: 'COMUNA 16',
			barrio: 'Brisas del Limonar'
		},
		{
			comuna: 'COMUNA 16',
			barrio: 'Área desocupada'
		},
		{
			comuna: 'COMUNA 16',
			barrio: 'Ciudad 2000'
		},
		{
			comuna: 'COMUNA 16',
			barrio: 'La Alborada'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'La Playa'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Primero de Mayo'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Ciudadela Comfandi'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Ciudad Universitaria'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Caney'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Lili'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Santa Anita - La Selva'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'El Ingenio'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Mayapan - Las Vegas'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Las Quintas de Don Simón'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Ciudad Capri'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'La Hacienda'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Los Portales - Nuevo Rey'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Cañaverales - Los Samanes'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'El Limonar'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Bosques del Limonar'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'El Gran Limonar - Cataya'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'El Gran Limonar'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Unicentro Cali'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Ciudadela Pasoancho'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Prados del Limonar'
		},
		{
			comuna: 'COMUNA 17',
			barrio: 'Urbanización San Joaquin'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Buenos Aires'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Barrio Caldas'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Los Chorros'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Meléndez'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Los Farallones'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Francisco Eladio Ramirez'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Prados del Sur'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Horizontes'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Mario Correa Rengifo'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Lourdes'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Colinas del Sur'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Alférez Real'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Nápoles'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'El Jordán'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Cuarteles Napoles'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Sector Alto de Los Chorros'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Polvorines'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Sector Meléndez'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Sector Alto Jordán'
		},
		{
			comuna: 'COMUNA 18',
			barrio: 'Alto Nápoles '
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'El Refugio'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'La Cascada'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'El Lido'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Urbanización Tequendama'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Barrio Eucarístico'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'San Fernando Nuevo'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Urbanización Nueva Granada'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Santa Isabel'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Bellavista'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'San Fernando Viejo'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Miraflores'
		},
		{
			comuna: 'COMUNA 19',
			barrio: '3 de Julio'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'El Cedro'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Champagñat'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Urbanización Colseguros'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Los Cambulos'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'El Mortiñal'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Urbanización Militar'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Cuarto de Legua - Guadalupe'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Nueva Tequendama '
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Camino Real - Joaquín Borrero Sinisterra'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Camino Real - Los Fundadores'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Altos de Santa Isabel -  La Morelia'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Santa Barbara'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Tejares - Cristales'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Unidad Residencial Santiago de Cali'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Unidad Residencial El Coliseo'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Cañaveralejo - Seguros Patria'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Cañaveral'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Pampa Linda'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'Sector Cañaveralejo Guadalupe'
		},
		{
			comuna: 'COMUNA 19',
			barrio: 'U.D. Alberto Galindo -  Plaza de Toros'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'El Cortijo'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'Belisario Caicedo'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'Siloé'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'Lleras Camargo'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'Belén'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'Brisas de Mayo'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'Tierra Blanca'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'Pueblo Joven'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'Carabineros'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'Venezuela - Urbanización Cañaveralejo'
		},
		{
			comuna: 'COMUNA 20',
			barrio: 'La Sultana'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Pízamos I'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Pízamos II'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Calimio Desepaz'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'El Remanso'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Los Líderes'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Desepaz Invicali'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Compartir'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Ciudad Talanga'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Villamercedes I - Villa Luz - Las Garzas'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Pízamos III - Las Dalias'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Potrero Grande'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Ciudadela del Río'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Valle Grande'
		},
		{
			comuna: 'COMUNA 21',
			barrio: 'Planta de Tratamiento'
		},
		{
			comuna: 'COMUNA 22',
			barrio: 'Urbanización Ciudad Jardín'
		},
		{
			comuna: 'COMUNA 22',
			barrio: 'Parcelaciones Pance'
		},
		{
			comuna: 'COMUNA 22',
			barrio: 'Urbanización Río Lili'
		},
		{
			comuna: 'COMUNA 22',
			barrio: 'Ciudad Campestre'
		},
		{
			comuna: 'COMUNA 22',
			barrio: 'Club Campestre'
		}
	]

	instituciones = [
		'LICEO MODERNO ARCO IRIS',
		'INSTITUTO TECNICO REAL HOLANDES',
		'INSTITUTO SER INTERNACIONAL DIAMANTE',
		'COLEGIO TECNICO JUVENIL DEL SUR',
		'INSTITUTO NACIONAL EBENEZER',
		'COLEGIO SENDEROS DE PAZ',
		'FUNDACIÃ“N COLEGIO GENERAL JOSE MARIA CORDOBA',
		'INSTITUTO  TECNICO CALIMA',
		'COLEGIO MIGUEL ANGEL BUONARROTI',
		'LICEO EL ENCUENTRO',
		'INSTITUTO DE EDUACCION COMFENALCO VALLLE',
		'INSTITUTO TECNICO DE EXCELENCIA EMPRESARIAL',
		'LICEO SANTA INES VALLEGRANDE',
		'INSTITUTO TECNICO CONSTRUCTORES DEL FUTURO',
		'CENTRO ETNOEDUCATIVO ANTONIO MACEO',
		'LICEO CAÃ‘AVERAL DE OCCIDENTE',
		'LICEO SAN ANTONIO',
		'COLEGIO LA ASUNCION',
		'LICEO JUVENIL COLOMBIA',
		'COLEGIO FUNDACION SANTA ISABEL DE HUNGRIA - ALFONSO LOPEZ',
		'INSTITUTO NTRA SRA DEL CARMEN',
		'COLEGIO DISTRITAL SAN JOSE',
		'NUESTRA SEÃ‘ORA DE LA PAZ',
		'COLEGIO SANTA LUISA DE MARILLAC',
		'INSTITUTO MAX SEIDEL',
		'CENTRO DE CAPACITACION SANTA INES',
		'INSTITUTO TECNICO DE COMERCIO Y SISTEMAS INTECOSIS LTDA',
		'COLEGIO LA DIVINA ENSEÃ‘ANZA',
		'LICEO SANTA CATALINA LABOURE',
		'LICEO COMERCIAL LA MILAGROSA',
		'INSTITUTO TECNICO COMERCIAL SANTA ROSA',
		'INSTITUTO LA RIVERA',
		'COLEGIO EL HOGAR',
		'SIMON RODRIGUEZ',
		'COLEGIO INPROVACC',
		'COLEGIO MIXTO LUZ Y VIDA',
		'INSTITUTO ANGELES DE DIOS',
		'COLEGIO LA PIEDAD',
		'CENTRO EDUCATIVO INDUSTRIAL LUIS MADINA',
		'INSTITUTO EDUCATIVO ALFA',
		'COLEGIO LAS PALMAS',
		'INSTITUTO TECNICO CCIAL DEL NORTE',
		'COLEGIO ARQUIDIOCESANO JUAN PABLO II',
		'COLEGIO CESAR CONTO SEDE PETECUY',
		'COLEGIO HERNANDO CAICEDO',
		'LICEO MAYOR MIXTO TERCER MILENIO',
		'COLEGIO SAN CAYETANO',
		'CENTRO DOCENTE SANTIAGO DE CALI',
		'LICEO BRILLANTE JUVENTUD',
		'PRINCIPE DE PAZ',
		'COLEGIO GIMNASIO TECNOLOGICO DEL PACIFICO',
		'CENTRO DOCENTE JUAN RAMON JIMENEZ',
		'COLEGIO RICHARD BACH',
		'COLEGIO VIDA NUEVA',
		'COLEGIO MIXTO CARLOS PAYAN',
		'CORP EDUC COLEGIO NIÃ‘O JESUS DE PRAGA',
		'COLEGIO PANAMERICANO',
		'COLEGIO CESAR CONTO',
		'LIC. SUPERIOR DEL VALLE NO.3',
		'COLEGIO MIX PEDRO MORALES PINO',
		'LICEO PEDAGÃ“GICO SURORIENTAL',
		'INSTITUTO TÃ‰CNICO RJ DEL SABER',
		'COLEGIO PARROQUIAL SAN JOAQUIN',
		'COLEGIO COMUNAL NUEVA GRANADA',
		'LICEO MIX EMPERADOR DE CALI',
		'LICEO SANTA CLARA',
		'COLEGIO YIZFRED ANTES CABAÃ‘ITA',
		'COLEGIO POLITECNICO SIGLO XXI',
		'CENTRO EDUCATIVO LEONARDO DA VINCI',
		'COLEGIO EL TESORO DEL SABER',
		'LICEO SUPERIOR DEL VALLE',
		'CORP EDUCATIVA ANTONIO MACEO',
		'LICEO SAN JOSÃ‰',
		'LICEO RAFAEL GARCIA HERREROS',
		'INSTITUTO TECNOLOGICO REY DE REYES II',
		'INSTITUTO LOPEZ',
		'COLEGIO COOPERATIVO NUESTRA SEÃ‘ORA DE LOS REMEDIOS',
		'LICEO MANUELA BELTRAN 2',
		'GENIOS DEL SABER',
		'LICEO MIXTO EMPERADOR II',
		'CORPORACION EDUCATIVA ADVENTISTA- CÃMBULOS',
		'COLEGIO CRISTIANO AMOR Y PAZ',
		'COLEGIO COMERCIAL NUEVA ERA VALLEGRANDE',
		'COLEGIO ACAD EL POBLADO',
		'COLEGIO MAYOR DEL NORTE 2 - PIZAMOS',
		'INSTITUTO COMERCIAL INDUSTRIAL Y TECNOLÃ“GICO ICIT',
		'COLEGIO GENERAL JOSE MARIA CORDOBA SEDE 2',
		'COLEGIO METROPOLITANO',
		'COLEGIO CIUDAD CORDOBA',
		'COLEGIO EMPRESARIAL MODERNO',
		'COLEGIO INGLATERRA REAL',
		'LICEO CERROS DEL VALLE',
		'CENT EDUC SEBASTIAN DE BELALCAZAR',
		'COLEGIO FE Y ESPERANZA MISION PANAMERICANA',
		'CENTRO DOCENTE  SANTIAGO DE CALI    3',
		'COLEGIO INTERNADO SAN CARLOS',
		'CENTRO DOCENTE SANTIAGO DE CALI #2',
		'INSTITUTO TÃ‰CNICO FUTURO PROFESIONAL',
		'COLEGIO MANUELITA SAENZ',
		'COL.CIAL. STA JUANA DE ARCO',
		'INSTITUTO NUESTRA SEÃ‘ORA DE LA ASUNCION',
		'INSTITUTO LA NUEVA ESPERANZA',
		'COLEGIO SANTA CRUZ',
		'LICEO ANDERSSON ECHEVERRY',
		'INSTITUTO TECNICO INDUSTRIAL Y COMERCIAL SIGLO XXI',
		'COLEGIO NUESTRA SEÃ‘ORA DE LA PROVIDENCIA',
		'LICEO SAGRADO CORAZÃ“N DE JESUS',
		'COLEGIO PARROQUIAL DIVINO SALVADOR',
		'COLEGIO PUERTA DEL SOL',
		'INSTITUTO TÃ‰CNICO INDSUTRIAL MANUEL ELKIN PATARROYO',
		'COLEGIO SAN SEBASTIAN',
		'CENTRO EDUCATIVO ALFA Y OMEGA',
		'LICEO NUEVA FLORESTA',
		'CENT  DOC JULIO ARBOLEDA',
		'FUNDACION COMUNITARIA MANUELA BELTRAN FUCOMABE',
		'CENTRO EDUCATIVO CRISTIANO SION',
		'INSTITUTO REMANSOS DE COMFADI',
		'COLEGIO MIXTO JUAN PESTALOZZI',
		'COLEGIO ORDEN Y LIBERTAD',
		'COLEGIO NUEVO SIGLO',
		'COLEGIO LICEO RENACER',
		'CENTRO EDUCATIVO COMUNITARIO OMAR TORRIJOS',
		'LICEO NAPOLITANO',
		'CORPORACIÃ“N EDUCATIVA POPULAR-LICEO DE LA AMISTAD',
		'LICEO MIXTO LAS LAJAS',
		'LICEO SAN MIGUEL',
		'LICEO JUAN CAMILO',
		'COLEGIO JESUS DE NAZARETH',
		'COLEGIO COMUNITARIO  TECNICO IND. UNIDAD BOLIVARIANA',
		'LICEO CALIMIO DESEPAZ',
		'CENTRO DOCENTE TERRANOVA',
		'COLEGIO FRANCISCO ELADIO RAMIREZ',
		'INSTITUTO DE CAPACITACION INCAP',
		'INSTITUTO TECNICO LATINOAMERICANO I',
		'LICEO MODERNO CIUDAD DE CALI',
		'CENTRO EDUCATIVO EMANUEL(DIOS CON NOSOTROS)',
		'LICEO FARALLONES DEL NORTE',
		'COLEGIO DE LAS AGUAS MONTEBELLO',
		'LICEO  JUVENIL  EL  RODEO',
		'CENTRO DE EDUCACION EN TECNOLOGIA CENTEC',
		'CENTRO DOCENTE LIGIA RESTREPO',
		'COLEGIO LAS ORQUIDEAS',
		'INSTITUTO CENTRAL DEL COMERCIO Y BACHILLERATO',
		'COLEGIO LOS ANGELES DEL NORTE DE OCCIDENTE',
		'COLEGIO LITORAL PACIFICO',
		'COLEGIO TECNICO CIAL SAN MARCOS DE LEON',
		'LICEO COLOMBIA JOVEN',
		'INSTITUTO TECNOLOGICO REY DE REYES I',
		'COLEGIO DANTE ALIGHIERI',
		'COLEGIO TECNICO CIAL DANA MARIA PAZ AMOR Y JUSTICIA',
		'LICEO FUTURO DE LOS NIÃ‘OS',
		'ASOC EDUC COLEGIO ARANGO Y CUERO',
		'INSTITUTO TECNICO COMERCIAL SANTO TOMAS',
		'INSTITUTO MODERNO DESEPAZ',
		'CENTRO EDUCATIVO AUTONOMO',
		'INSTITUTO MODERNO',
		'CENT EDUC SEMILLAS DE VIDA',
		'CENT DOC LA VICTORIA',
		'LICEO COLOMBO IRLANDES',
		'CENT EDUC JUAN CARLOS GARZON',
		'INSTITUTO TECNICO COMERCIAL  COLOMBO LIBANES',
		'COLEGIO COLINAS DE PIAMONTE',
		'LICEO DOCENTE LA PLAYA',
		'COLEGIO AMOR Y CIENCIA',
		'COLEGIO MIX JESUS DE NAZARENO',
		'LICEO LA DIVINA PROVIDENCIA',
		'COLEGIO HORIZONTES',
		'COL.  GENERAL PEDRO ALCÃNTARA HERRÃN',
		'COLEGIO MICROEMPRESARIAL JOSÃ‰ PARDO LÃ“PEZ',
		'LICEO PORVENIR',
		'LICEO MIXTO LA MILAGROSA',
		'FUNDACION ESCOLAR NELSON MANDELA',
		'LICEO BOLIVARIANO DEL SUR',
		'COLEGIO CULTURAL ENMANUEL',
		'ESC. DE LA TRINIDAD',
		'ASODISVALLE',
		'ESC ADVENTISTA DE BETHEL',
		'COLEGIO MIXTO SANTO TOMAS',
		'COLEGIO PORFIRIO BARBA JACOB',
		'COLEGIO BAUTISTA EMAUS',
		'CENTRO DOCENTE NICOLAS BORRERO',
		'COLEGIO TOMAS VASCONI',
		'COLEGIO JOHANNES GUTENBERG',
		'COLEGIO ALEXANDER',
		'COLEGIO FRAY LUIS FERRER',
		'ESCUELA MARCELINO',
		'COLEGIO TECNICO JUVENIL DEL VALLE',
		'COLEGIO MORICHAL DEL SABER',
		'CENTRO DOCENTE CASITA DE BELEN',
		'COLEGIO COMERCIAL MARIA INMACULADA',
		'COLEGIO CRISTIANO ESTRELLA DE DAVID',
		'LICEO MODERNO LOS ROBLES',
		'COLEGIO CENTRAL MADRID',
		'INSTITUTO DE EDUCACION TECNICA  ICET',
		'INSTITUTO POLITÃ‰CNICO COMUNA 21.',
		'COLEGIO PARROQUIAL SAN FRANCISCO JAVIER',
		'INST. EDUC. VOZ DE PAZ',
		'COLEGIO EL SENDERO DEL FUTURO',
		'INSTITUTO PEDAGOGICO EMANUEL',
		'LICEO COMERCIAL SANTIAGO NIAMPIRA',
		'CENTRO DOCENTE LICEO MARISOL',
		'INSTITUTO TECNICO LOS SABIOS DEL FUTURO',
		'LICEO MELVIN JONES',
		'COLEGIO DE JESÃšS',
		'GIM. EDU. ATENEA',
		'COLEGIO SANTA LUCIA',
		'LICEO LAS AMERICAS',
		'COLEGIO NUEVO HORIZONTE',
		'COL. LORENCITA VILLEGAS',
		'COLEGIO REPÃšBLICA DEL SALVADOR',
		'LICEO EDUC APOSENTO ALTO',
		'COLEGIO LA SAGRADA FAMILIA  A.C.S.L.G',
		'LICEO PIGMALION',
		'LICEO PEDAGÃ“GICO LA ALEGRÃA DE NINI',
		'INSTITUTO TECNICO JUVENIL DEL VALLE',
		'INSTITUTO DE BACHILLERATO TECNOLOGICO DANIEL GILLARD',
		'LICEO SANTA INES-ANDES',
		'INSTITUTO COLOMBIANO DE BACHILLERATO',
		'LICEO INFANTIL LAS MARGARITAS',
		'CENTRO DOCENTE BARTOLOME MITRE',
		'CENTRO DOCENTE NUEVA GRANADA',
		'COLEGIO LA MILAGROSA',
		'ESCUELA PILOTO FUNDACION HAROLD H. EDER',
		'COLEGIO ESPERANZA DEL REMANSO',
		'LICEO MIS PRIMEROS TRIUNFOS',
		'COLEGIO BRIGADA SOCIAL GELVER',
		'COL. JUVENIL DE CALI',
		'COLEGIO SAN AGUSTIN',
		'LICEO INFANTIL LEÃ“N DE JUDÃ',
		'COLEGIO ADVENTISTA EL CORTIJO',
		'INSTITUTO ELIZABETH LORZA',
		'COLEGIO  JUAN JACOBO ROUSSEAU',
		'COLEGIO LA FLORALIA',
		'LICEO EDUCATIVO GENTE DEL SABER',
		'COLEGIO NUEVO EDEN',
		'INSTITUTO EDUC CASTELL',
		'LICEO INFANTIL LOS PEQUEÃ‘OS CISNES',
		'LICEO SUPERIOR STEVEN',
		'LICEO INFANTIL LUCERITOS',
		'LICEO MIXTO EMPERADOR DE CALI III',
		'CENT EDUC SAN JUAN DE LA CRUZ',
		'LICEO NUEVA ERA',
		'COLEGIO TOMAS CARRASQUILLA CALI',
		'COLEGIO PEQUEÃ‘OS INVESTIGADORES',
		'INSTITUTO ELIM INTERNACIONAL',
		'COLEGIO NUESTRA SEÃ‘ORA DE FATIMA',
		'SEBASTIAN I',
		'COLEGIO LA FONTAINE  - LUCERITOS 2',
		'COLEGIO JUVENIL RENACER',
		'LICEO SAN FRANCISCO',
		'C.E. VALLE DEL CAUCA CEVALLE',
		'COLEGIO SANTA  JUANA DE ARCO SEDE # 2',
		'NUESTRA SEÃ‘ORA DE GUADALAJARA',
		'COLEGIO TÃ‰CNICO SAN SEBASTIAN NÂ°2',
		'COLEGIO NUESTRO FUTURO',
		'INSTITUTO MORENO DEL CASTILLO',
		'LICEO NUEVA EUCARISTÃA',
		'COLEGIO SAN FRANCISCO SOLANO',
		'COLEGIO FRANCISCO DE ASIS',
		'COLEGIO ULPIANO LLOREDA',
		'LICEO ANDALUZ',
		'LICEO LUIGI ORIONE',
		'HOGAR JUVENIL CAMPESINO EL HORMIGUERO',
		'COL. MIS PRIMERAS LUCES',
		'CENT EDUC  NUESTRO AMANECER',
		'INSTITUTO EDUCATIVO GUALANDAY',
		'COLEGIO MIXTO SANTO DOMINGO SAVIO',
		'COLEGIO BAUTISTA BETANIA',
		'GIMNASIO MARCO FIDEL SUÃREZ',
		'LICEO CRISTIANO GENIOS DEL MAÃ‘ANA',
		'LICEO AUSUBEL',
		'COLEGIO  SANTA  ISABEL',
		'CENTRO EDUCATIVO CREAR',
		'LICEO LA BELLA EPOCA',
		'LICEO MI REFUGIO',
		'LICEO SAN JUAN APOSTOL',
		'CENTRO EDUCATIVO ROSSY',
		'CENT. EDUC.SEMILLITAS',
		'CENT EDUC SENDERITOS',
		'LICEO LA TRINIDAD',
		'LICEO CRISTIANO DEJANDO HUELLA',
		'LICEO INFANTIL CRECIENDO',
		'COL. COMUNIT. IVAN DARIO LOPEZ',
		'COLEGIO LAS MERCEDITAS',
		'CENTRO EDUCATIVO TERRA NOVA',
		'CENT DOC MARIA DEL CARMEN',
		'LICEO INF CARITAS FELICES',
		'COLEGIO  REAL  SUIZO',
		'COLEGIO SOCIEDAD DE CRISTO',
		'LICEO INFANTIL FANTASIAS',
		'LICEO COLOMBIANITOS DEL MAÃ‘ANA',
		'INSTITUTO SANTA ANITA',
		'CENTRO EDUC Y ESC MATERNAL MANOS CREATIVAS',
		'LICEO INFANTIL DANNY',
		'LICEO PORVENIR II',
		'LIC. BERTOL BRECHT',
		'LICEO INFANTIL FORJADORES DEL FUTURO',
		'COLEGIO SANTA JUANA',
		'CENT DOC MIX NUEVO HORIZONTE',
		'LICEO COMERCIAL SANTA LUCIA',
		'LICEO IDEAS INFANTILES',
		'COLEGIO LOS TURPIALES',
		'COLEGIO SANTA FILOMENA',
		'INSTITUTO  NIÃ‘A MARIA',
		'C.E. SAN CARLOS',
		'LICEO LOS GUAYUPINES',
		'COLEGIO MAYOR DEL NORTE',
		'INSTITUTO TÃ‰CNICO EN SISTEMAS CARO Y CUERVO',
		'LICEO PEDAGOGICO LOS TRIUNFADORES',
		'GRANJA ESCUELA NUEVA PBRO. SEBASTIAN ALDOMÃ BONJOCH - MIRAVALLE',
		'CENT DOC PARROQ SAN MARCOS',
		'INSTITUTO PARA NIÃ‘OS CIEGOS Y SORDOS DEL VALLE DEL CAUCA',
		'CENTRO PEDAGOGICO AVENTURAS DEL SABER',
		'CENTRO INTEGRAL DE APRENDIZAJE SAN JUANITO',
		'FUNDACIÃ“N FECIM UN MUNDO DE SUEÃ‘OS',
		'LICEO INF VENTANITA DEL SABER',
		'COLEGIO TECNICO COMERCIAL LUCES DEL SABER',
		'LICEO ILLARE',
		'JARDIN INFANTIL ANEXO FACUL. EDU. U.S.B.',
		'CENT DOC HORIZONTES DEL FUTURO',
		'LICEO MIXTO RAYO DE LUZ',
		'CENTRO EDUCATIVO SOL NACIENTE',
		'LIC. FUENTE DE AMOR',
		'LICEO INFANTIL LOS DELFINES',
		'JARDIN INFANTIL LAURITA',
		'ESTABLECIMIENTO EDUCATIVO EL CARRUSEL DEL SABER',
		'LICEO EDUCATIVO CHICATOS',
		'JARD INF PEQUEÃ‘OS CONSTRUCTORES LTDA',
		'LICEO INFANTIL MUNDO MÃGICO',
		'CENTRO EDUCATIVO HOMBRES DEL FUTURO',
		'JARD INF SONRISAS',
		'LICEO INFANTIL GUILLERMO VALENCIA',
		'LICEO MATERNO INFANTIL GENESIS',
		'TALLER INF ABEJITAS LABORIOSAS',
		'LICEO INFANTIL MI PEQUEÃ‘O MUNDO',
		'COLEGIO COMPARTIR',
		'JARDIN INFANTIL RETOÃ‘ITOS',
		'CENTRO EDUCATIVO FE Y ALEGRIA MADRE SIFFREDI',
		'LICEO GENIOS EN ACCION',
		'LICEO INFANTIL AVENTURAS',
		'COLEGIO MIXTO CANAAN',
		'LICEO INFANTIL LA CASITA DE AIRE Y SOL',
		'CENTRO EDUCATIVO IDEAL',
		'ESCUELA DE GESTION Y FORMACION EMPRESARIAL',
		'INST. EDU. NO FORMAL ANDRES BELLO COLOMBO AMERICANO',
		'INSTITUTO SER INTERNACIONAL COMUNA 17',
		'COLEGIO DE LA CAJA DE COMPENSACION FAMILIAR DEL VALLE DEL CAUCA “COMFANDI”',
		'TERRA INSTITUTO',
		'INSTITUTO LA CAMPIÃ‘A',
		'COLEGIO LOS ANDES N 2',
		'INSTITUTO COLOMBIA',
		'INST. TECN. HERMANO MIGUEL',
		'COLEGIO GUIAS',
		'CENTRO DE ESTUDIOS E INVESTIGACIÃ“N VIDA CEVIDA',
		'CORPORACION NACIONAL DE ESTUDIOS',
		'CENTRO DE ESTUDIOS PARA LOS SISTEMAS DE INFORMACION CESI',
		'CENTRO DOCENTE SANTA ANITA',
		'CENTRO DE ESTUDIOS FUTUROS',
		'INSTITUTO IPANA',
		'INSTITUTO CAMILO TERREROS',
		'I.E. DEL VALLE',
		'CENTRO DE ESTUDIOS INSCAT',
		'COLEGIO LEON DE GREIFF',
		'INSTITUTO BOLIVARIANO ESDISEÃ‘OS DEL',
		'INST. PARA EL DESARROLLO DE LA CIENCIA',
		'LICEO LOS PINOS',
		'INSTITUTO TÃ‰CNICO SAN JUAN',
		'COLEGIO COOPERATIVO LINO GIL JARAMILLO',
		'CENTRO DE ESTUDIOS ACADEMICOS C.E.A',
		'COLEGIO DE NUESTRA SEÃ‘ORA DE CHIQUINQUIRA',
		'COLEGIO MAYOR SAN FRANCISCO DE ASIS',
		'CENTRO EDUCATIVO INSCAT',
		'CORPORACION EDUCATIVA ALEXANDER VON HUMBOLDT',
		'COLEGIO MAYOR SANTIAGO DE CALI',
		'EDUCACION FORMAL POR CICLOS CETECNICO NO. 2',
		'INCOVAL',
		'INSTITUTO TECNICO LA RIVIERA',
		'COLEGIO CLARETIANO SANTA DOROTEA',
		'COLEGIO PARROQ SAN JUAN BAUTISTA',
		'INTITUTO GRAN COLOMBIA',
		'LICEO MAYOR TECNICO DEL VALLE',
		'LICEO LATINO',
		'COLEGIO NUEVO CAMBRIDGE',
		'INSTITUTO CIAL ARQUIDIOCESANO',
		'FUNDACION EDUCATIVA LIDERES',
		'COLEGIO SAN PEDRO CLAVER',
		'COLEGIO BRITÃNICO-THE BRITISH SCHOOL',
		'INSTITUTO TÃ‰CNICO OCUPACIONAL ITO',
		'COLEGIO MILITAR JOSE ACEVEDO Y GOMEZ',
		'COLEGIO REYES CATOLICOS',
		'COLEGIO COMFANDI EL PRADO',
		'COLEGIO ANDINO',
		'EDUCACIÃ“N FORMAL POR CICLOS CETEC',
		'INSTITUTO TÃ‰CNICO DE CAPACITACIÃ“N INTEGRAL  ITECI',
		'COLEGIO MAYOR ALFEREZ REAL',
		'INSTITUTO TÃ‰CNICO INDUSTRIAL SAN JUAN BOSCO',
		'COLEGIO BILINGÃœE LANCASTER',
		'LICEO BELLA SUIZA',
		'CORPORACION COLEGIO AMERICAS UNIDAS',
		'CENTRO DE EDUCACION INDIVIDUALIZADA',
		'COLEGIO DE ADULTOS NUESTRA SEÃ‘ORA DE LAS MERCEDES',
		'FUND COLEGIO PAR SAN PEDRO CLAVER',
		'CENT EDUC PROGRESEMOS',
		'LICEO SANTA INES',
		'COMFANDI MIRAFLORES',
		'COLEGIO LUIS CARLOS GALAN SARMIENTO',
		'LICEO COMERCIAL Y TECNOLOGICO DEL VALLE',
		'ACADEMIA DE CIENCIAS DE COLOMBIA AKADEMOS',
		'LICEO ANGLO DEL VALLE',
		'COLEGIO CREAD',
		'FUNDACION EDUCATIVA JOSE ANGEL HERRERA MORA',
		'FUND COLEGIO SANTA ISABEL DE HUNGRIA - CIUDAD 2000',
		'COLEGIO COMFANDI CALIPSO',
		'COLEGIO LOS ANDES',
		'COLEGIO CENTRO DE ARTE JUVENILIA',
		'COLEGIO SAN ALBERTO MAGNO',
		'COLEGIO SAN FRANCISCO DE ASIS',
		'COLEGIO PARROQUIAL NUESTRA SEÃ‘ORA DE LOS ANDES',
		'COLEGIO EL AMPARO',
		'COLEGIO TECNICO NUEVO SALOMIA',
		'FUNDACION EDUCATIVA PABLO VI COLEGIO PARROQUIAL NUESTRA SEÃ‘ORA DE GUADALUPE',
		'INSTITUTO EDUCATIVO GALILEO GALILEI',
		'COLEGIO MILITAR ALMIRANTE COLON DE CALI',
		'COLEGIO PARROQIAL SANTIAGO APOSTOL',
		'LA PRESENTACION EL PARAISO',
		'COLEGIO NTRA SRA DE LA ANUNCIACION',
		'COLEGIO MIXTO SAN VICENTE',
		'CORPORACION EDUCATIVA INSTITUTO COLOMBIANO DE ESTUDIOS TECNICOS',
		'LICEO CARLOS CASTRO SAAVEDRA',
		'COLEGIO SAN JOSE - SEDE CHAMPAGNAT',
		'COLEGIO AMERICANO',
		'COLEGIO LOS ANGELES DEL NORTE',
		'COLEGIO SAN IGNACIO DE LOYOLA',
		'COLEGIO SAN ANTONIO MARIA CLARET',
		'COL. TEC. COMERCIAL SANTA MARIA GORETTY',
		'COLEGIO BAUTISTA',
		'LICEO SAN JUAN XXIII',
		'COLEGIO TECNICO MARIA ELVINIA',
		'SANTA  MARIA STELLA MARIS',
		'COLEGIO SAN FRANCISCO JAVIER',
		'COLEGIO LEONÃSTICO LA MERCED',
		'COLEGIO MAYOR SAN ANTONIO DE PADUA',
		'COL. NUESTRA SEÃ‘ORA DE LA GRACIA',
		'ACADEMIA GENERAL JOSE MARIA CABAL',
		'COLEGIO SAN FERNANDO REY',
		'COLEGIO PERSONALIZADO PENSARTE',
		'COLEGIO EL CARMELO',
		'COLEGIO IDEAS',
		'LICEO QUIAL',
		'COLEGIO EKKLESIA',
		'COLEGIO NUESTRA SEÃ‘ORA DEL ROSARIO',
		'LICEO SUPERIOR JUAN PABLO II',
		'COLEGIO FRANCISCANO DE FRAY DAMIAN GONZALEZ',
		'CENT DOC FEDERICCI',
		'COLEGIO EL PINAR',
		'COLEGIO HISPANOAMERICANO',
		'COLEGIO DE LA SANTÃSIMA TRINIDAD',
		'COLEGIO BERCHMANS',
		'CENTRO DOCENTE TOMAS CIPRIANO  MOSQUERA',
		'COLEGIO SAN AMBROSIO DE MILAN',
		'COLEGIO FRANCISCANO  PÃO XII',
		'COLEGIO COOMEVA',
		'GIMNASIO LOS FARALLONES',
		'INSTITUTO TECNICO SALOMIA',
		'COLEGIO CATOLICO',
		'INST. TEC. CIAL GENERAL SANTANDER',
		'COLEGIO VALORES ILAMA',
		'SANTA MARIANA DE JESÃšS',
		'COLEGIO MARIA AUXILIADORA',
		'COLEGIO NUESTRA SEÃ‘ORA DE LA CONSOLACION',
		'COLEGIO CIUDADELA EDUC LA PRESENTACIÃ“N',
		'ACADE MILITAR JOAQUÃN DE CAYZEDO Y CUERO',
		'COLEGIO LACORDAIRE',
		'INSTTIUCIÃ“N EDUCATIVA COLEGIO SAN JOSÃ‰ REFUGIO',
		'COLEGIO EL BOSQUE',
		'COLEGIO CAMPESTRE ANGLO HISPANO',
		'LICEO MODERNO INTERANDINO',
		'COLEGIO LOS ANGELES SAN FERNANDO',
		'COLEGIO PRINCIPITO DE LOS ANDES',
		'COLEGIO ECOLOGICO SCOUTS',
		'COLEGIO ANGLO AMERICANO',
		'CENTRO EDUCATIVO ETIEVAN -  COLEGIO ENCUENTROS',
		'COLEGIO DEL SAGRADO CORAZÃ“N DE JESÃšS-VALLE DEL LILI',
		'COLEGIO DE LA SAGRADA FAMILIA',
		'COLEGIO LA ARBOLEDA',
		'COLEGIO PHILADELPHIA INTERNACIONAL',
		'ASPAEN LICEO TACURÃ',
		'LICEO BENALCAZAR',
		'COLEGIO BILINGUE MONTESSORI',
		'COLEGIO COLOMBO BRITÃNICO',
		'INSTITUTO BILINGUE AGORA',
		'COLEGIO BILINGUE DIANA OESE',
		'COLEGIO LAURETTA BENDER',
		'COLEGIO DE SAN LUIS GONZAGA',
		'VERNOT SCHOOL',
		'LICEO NUESTRA SEÃ‘ORA DE LOURDES',
		'COLEGIO MIGUEL CAMACHO PEREA',
		'CORPORACIÃ“N CULTURAL COLEGIO ALEMÃN',
		'COLEGIO MIXTO LAWRENCE KOHLBERG (JARDIN INFANTIL BAMBINOS)',
		'INSTITUTO SAN JUAN EUDES',
		'COLEGIO LUIS HORACIO GOMEZ',
		'SUEÃ‘OS MARAVILLOSOS',
		'LICEO CAMPESTRE INGLES DEL SUR',
		'COLEGIO BENNETT',
		'ASPAEN COLEGIO JUANAMBÃš',
		'COLEGIO BOLIVAR',
		'COLEGIO FREINET',
		'COLEGIO COMFANDI SAN NICOLÃS',
		'COLEGIO GIMNASIO LA COLINA',
		'COLEGIO COMFANDI CIUDADELA',
		'COLEGIO BILINGUE WASHINGTON',
		'LICEO LOS ALPES INSTITUCION EDUCATIVA S.A.S.',
		'COLEGIO INGLES DE LOS ANDES',
		'INSTITUTO NUESTRA SEÃ‘ORA DEL PERPETUO SOCORRO',
		'COL.SANTA MARIA DE PANCE',
		'LICEO FRANCES PAUL VALERY',
		'LICEO ALTHAIR',
		'INSTITUTO ADONAY',
		'LICEO REAL MONTESSORI',
		'COLEGIO COMFANDI MUNICIPAL',
		'LICEO PAULO FREIRE',
		'COLEGIO COMFANDI LAS DELICIAS',
		'LICEO COMPUTARIZADO SISTEVALLE',
		'CENTRO PRADOS DE ORIENTE COMFANDI',
		'LICEO MUNDO DINAMICO',
		'CENTRO EDUCATIVO SHALOM CALI',
		'LICEO LUZ DEL SABER',
		'COLEGIO MI FORTALEZA',
		'LICEO IGUAZU',
		'COLEGIO LOS MARINERITOS',
		'COLEGIO SENDEROS DEL LILI',
		'LIC. INF. SAUCES DEL VALLE',
		'LICEO INF TRAVESURAS DE GUILLE',
		'COLEGIO MIS RETOÃ‘ITOS',
		'COLEGIO EL SABER',
		'COLEGIO LOS SAUCES',
		'LICEO JUVENTUDES',
		'LICEO INF MARCO',
		'LICEO INFANTIL SEMILLITAS',
		'COLEGIO ALEGRE HORIZONTE',
		'COLEGIO LOS ALMENDROS',
		'ACADEMIA DARSHAN',
		'LICEO CARLOS A GARCIA S',
		'LIC. ANDREWS',
		'LICEO LAS ACACIAS',
		'COLEGIO JARD INF GENTE MENUDA',
		'CENTRO INTEGRAL DE ESTIMULACION APRENDER',
		'COLEGIO PORTALES',
		'CENTRO EDUCATIVO BARRANQUILLA',
		'COLEGIO AURA MARIA',
		'COLEGIO RECUERDOS DEL NIÃ‘O',
		'LICEO RISAS INFANTILES.',
		'COLEGIO INFANTIL BELEN',
		'LICEO ISABELLA',
		'COLEGIO SANTA TERESITA DE AVILA',
		'COLEGIO KONRAD LORENZ',
		'LICEO INFANTIL ESTRELLITAS CREATIVAS',
		'CENTRO EDUCATIVO PENSAR Y ARTE',
		'JARDÃN INFANTIL TÃA CLARITA',
		'COLEGIO CRISTIANO TORRE FUERTE',
		'LICEO PIAGET',
		'JARDIN INFANTIL PARAISO DE LOS NIÃ‘OS',
		'JARDIN INFANTIL SOÃ‘ADORES',
		'LA CASITA DE LOS SUEÃ‘OS JARDIN INFANTIL BILINGUE',
		'INSTITUTO DOC ROSALÃA PERLAZA',
		'CENTRO INFANTIL MI BEBE FELIZ E.U.',
		'LICEO INFANTIL MELOSITOS',
		'LICEO INFANTIL LUCECITAS',
		'LICEO CAMPESTRE PULGARCITO',
		'JARDÃN INFANTIL MORISOT',
		'CENTRO DE ESTIMULACIÃ“N ADECUADA SUEÃ‘OS DE TASHLIN',
		'ESCUELA MATERNAL Y JARDIN INFANTIL EL CLUB DE LOS CHICOSSIN NOMBRE',
		'JARDIN INFANTIL TRAVESURAS DE WINNY',
		'LICEO INF RINCÃ“N DE EXPERIENCIAS',
		'JARDIN INFANTIL AÃ‘OS BELLOS',
		'JARDIN INFANTIL MICKEY MOUSE',
		'JARD INF Y GUARDERÃŒA JOSÃˆ MIEL',
		'JARDÃN INFANTIL ARTESANITOS',
		'JARDIN INFANTIL EL OSO MELOSO',
		'JARD. INF. MATERNAL ESTIMULOS',
		'JARDIN INFANTIL Y ESCUELA MATERNAL PEPE GRILLO',
		'LICEO INFANTIL QUERUBINES',
		'JARDIN INFANTIL PARQUE OLIMPICO',
		'JARDIN INFANTIL Y ESCUELA MATERNAL LOS BULLICIOSOS',
		'JARDI INFANTIL MIGUELIN RAYIN',
		'JARDIN INFANTIL COLORIN COLORADO',
		'JARDIN INFANTIL CASITA DE CHOCOLATE',
		'LICEO INFANTIL ALEGRE DESPERTAR',
		'INSTITUTO EDUC COLEGIO AOZORA',
		'JARDIN INFANTIL PIOLIN',
		'CENTRO EDUCATIVO FANTASIAS DEL SABER',
		'COLEGIO CARLOS CASTRO SAAVEDRA',
		'LICEO SEMILLAS DE PAZ',
		'JARDIN INFANTIL PEQUEÃ‘OS GENIOS',
		'CENTRO EDUCATIVO SHALOM ALEJEM - ANTES JARDIN INFANTIL BURBUJITAS MATERNAL',
		'ESC. MATER. Y JAR. INF. PILATUNAS',
		'ESCUELA MATERNAL BILINGUE TATAS LTDA',
		'LICEO INF SENDEROS DE ALEGRIA',
		'JARDÃN Y GUARDERÃA AFIRMANDO MIS PASOS',
		'LICEO INFANTIL UN MUNDO DE SUEÃ‘OS',
		'JARDIN INFANTIL MI PEQUEÃ‘O ASIS',
		'JARDIN INFANTIL VERSALLES',
		'JARDIN INFANTIL SENDEROS DE  SABIDURIA',
		'MATERNAL BAM BAM',
		'KINDER ESPECIALIZADO BAM BAM',
		'LICEO VIGOTSKI',
		'LICEO INFANTIL Y GUARDERIA PIO PIO',
		'LICEO CAMPESTRE MI EDAD FELIZ',
		'JARD. INF. LA CASITA DE DULCE',
		'CENT. MATERNO INFANTIL CARRUSEL DE LA ALEGRIA',
		'MATERNAL Y JARDIN INFANTIL IDEAS CREATIVAS',
		'JARDIN INFANTIL TRAZOS Y LETRAS',
		'COLEGIO COMUN JARD DE JESUS',
		'COLEGIO CARAVANA DE SORPRESAS',
		'LICEO INFANTIL PALACIO DE LOS SABIOS',
		'JARDIN INFANTIL SEMILLITAS DEL FUTURO',
		'JARDÃN INFANTIL SANTIAGUITOS',
		'ASPAEN MATERNAL Y PREESCOLAR ENTREVALLES',
		'JARDIN INFANTIL MI MUNDO CREATIVO',
		'LICEO INFANTIL MI DULCE REFUGIO',
		'CASA MATERNAL GOTITA DE GENTE',
		'EXPRESAR JARDIN INFANTIL',
		'LICEO INFANTIL GENIOS DEL FUTURO',
		'COLEGIO HELEN KELLER',
		'JARDÃN INFANTIL MENTES PSICODINÃMICAS',
		'JARDIN INFANTIL MI CASITA DE AZUCAR',
		'COLEGIO LA ESTRELLA DE LA SABIDURIA',
		'LICEO INFANTIL SOBRINITOS',
		'JARDIN INFANTIL MARIA PATRICIA',
		'JARDIN INFANTIL Y TALLER CREATIVO SENDEROS DEL ARTE',
		'JARD INF LA PANDILLA DE LULU',
		'JARDIN PARROQUIAL DEL CORAZON DE MARIA',
		'CENTRO DE ESTIMULACION PRECOZ CRECER',
		'JARDIN INFANTIL Y ESCUELA MATERNAL EL PEQUEÃ‘O MUNDO',
		'JARDIN INFANTIL PIRUETAS',
		'JARDIN INFANTIL CHISPITAS',
		'TALLER DE ANIK JARDÃN INFANTIL',
		'JARDIN INFANTIL APRENDAMOS',
		'LOS PITUFOS JARDIN INFANTIL',
		'FUNDACION EDUCATIVA LICEO ROSITA',
		'JARDÃN INFANTIL Y ESCUELA MATERNAL EL PATICO',
		'JARDIN INFANTIL Y ESCUELA MATERNAL MI UNIVERSO',
		'JARDIN INFANTIL BILINGUE TESOROS DEL SABER',
		'JARDIN INFANTIL CASITA DE LOS SUEÃ‘OS',
		'GIMNASIO DEL NORTE CENTRO DE ESTIMULACION CHIQUIMIMOS',
		'JARDIN INFANTIL EL TALLER DE LOS TRAVIESOS',
		'LICEO Y SALA MATERNAL  LA FUENTE DEL SABER',
		'LICEO   EL JARDIN',
		'JARDIN INFANTIL Y ESCUELA MATERNAL EL PRINCIPITO',
		'JARDIN INFANTIL UN MUNDO POR CREAR',
		'JARDIN INFANTIL MARIA VICTORIA',
		'MIS PEQUEÃ‘OS PRINCIPIANTES',
		'JARDIN INFANTIL ESCUELA MATERNAL PATY PATICOS',
		'LICEO INFANTIL GOTITAS DE LLUVIA',
		'LICEO CANGURITOS ALEGRES',
		'LICEO INFANTIL MUNDO MIEL',
		'LICEO UN MUNDO DEL SABER',
		'LICEO INFANTIL LOS TOPITOS',
		'LICEO INFANTIL MI MUNDO DE COLORES',
		'JARDIN ARMONIA INFANTIL',
		'LICEO EDUCATIVO  ALEGRÃA DE COMPARTIR',
		'ESCUELA MATERNAL MIRRINGA MIRRONGA',
		'JARD. INFANTIL MANOS CREATIVAS',
		'C.E. PARA ADULTOS A.B.C.',
		'COLEGIO HELEN KELLER - SEDE DE PANCE',
		'ASPAEN PREESCOLAR TAYANA',
		'JARD Y ESCUELA MATERNAL PULGARCITO LTDA',
		'JARDIN INFANTIL MIS PRIMERAS LETRAS',
		'MATERNAL Y JARDIN INFANTIL ESTRELLITA DE MAR',
		'JARDÃN INFANTIL JUEGOS ARTES Y LETRAS',
		'JARDIN INFANTIL MI CASITA ENCANTADA',
		'ESCUELA MATERNAL Y PREESCOLAR COMETAS',
		'JARDÃN INFANTIL Y GUARDERÃA SANTA ISABEL',
		'JARDIN INFANTIL TIA CECILIA',
		'CENTRO DE ESTIMULACION TEMPRANA CAET',
		'LICEOS EJERCITO PICHINCHA',
		'Isaías Gamboa',
		'La Inmaculada',
		'José Celestino Mutis',
		'José Holguín Garcés - Sede Principal',
		'Ana Maria Lloreda',
		'Marice Sinisterra',
		'Villa Del Mar',
		'Ulpiano Lloreda',
		'José Acevedo y Gomez',
		'Luis Fernando Caicedo - Sede Principal',
		'Cecilia Caballero de López',
		'Alejandro Cabal Pombo',
		'El Aguacatal',
		'República  de Brasil',
		'República de Brasil Alto Menga',
		'Técnico de Comercio Santa Cecilia 1',
		'República de Francia',
		'Brisas de Los Álamos',
		'La Inmaculada',
		'Manuel Sinisterra Patino',
		'Maria Perlaza',
		'Santa Librada-Sede Carlos A.Sardi G.',
		'Normal Superior Farallones de Cali',
		'Club Noel',
		'Salvador Iglesias',
		'Martin Restrepo Mejía',
		'Santa Librada',
		'Santa Librada-Sede Luis Carlos Pena',
		'Santa Librada-Sede Santiago De Cali',
		'Santa Librada- Sede República de México',
		'Santa Librada- Sede El Piloto',
		'Manuela Beltrán',
		'Jorge Isaacs',
		'Cendoe',
		'Republica de Israel',
		'Manuel Santiago Vallecilla',
		'San José',
		'La Merced',
		'San Vicente de Paul',
		'San Pedro Alejandrino',
		'Técnico Industrial Veinte de Julio',
		'Cristina Serrano',
		'Santo Tomás de Aquino',
		'Guillermo Valencia',
		'José Antonio Galán',
		'Rafael Zamorano',
		'Ignacio Rengifo',
		'Absalón Fernández De Soto',
		'Veintiuno de Septiembre',
		'Camilo Torres',
		'Centro Educativo del Norte',
		'Presbítero Ángel Piedrahita',
		'Santo Tomas  CASD',
		'Jorge Isaacs Inem',
		'Fray Domingo de Las Casas',
		'Simón Rodríguez - Barrio Sena',
		'Maria Panesso',
		'Mario Lloreda',
		'Mariano Ospina Perez',
		'Celmira Bueno de Orejuela',
		'Pedro Antonio Molina',
		'San Luis',
		'Jorge Eliecer Gaitán',
		'Pablo Emilio Caicedo',
		'Atanasio Girardot',
		'Tres de Julio',
		'San Jorge',
		'Inmaculada Concepción',
		'Las Américas',
		'Cecilia Munoz Ricaurte',
		'Los Vencedores',
		'Alfonso López Pumarejo - Barrio Alfonso López  Iii',
		'Carlos Villafañe',
		'José Maria Villegas',
		'Purificación Trujillo',
		'Central Provivienda',
		'Los Farallones',
		'Vicente Borrero Costa',
		'Pebro Eloy Valenzuela',
		'Institución Educativa Alfonso López Pumarejo',
		'Rafael Pombo',
		'Manuel Maria Mallarino',
		'Juan Bautista De La Salle',
		'Siete de Agosto',
		'Eleazar Libreros',
		'Unidad Vecinal Siete de Agosto',
		'Ana Maria Vernaza',
		'Los Pinos',
		'Carlos Holguín Sardi',
		'Manuel Maria Mallarino - Barrio Las Ceibas',
		'Laura Vicuña',
		'José Hilario López',
		'Evaristo García',
		'Saavedra Galindo',
		'Fernando De Aragón',
		'Puerto Rico',
		'Manuel Rebolledo',
		'Benjamín Herrera',
		'José Manuel Saavedra Galindo',
		'Nuestra Señora de Fátima',
		'Cacique De Guatavita',
		'Santísima Trinidad',
		'Nuestra Señora de Loreto',
		'Atanasio Girardot',
		'Las Américas',
		'Rafael Uribe',
		'Gabriel Montano',
		'Santa Fe',
		'Ricardo Nieto',
		'Croydon',
		'Bajo Palace',
		'Villacolombia',
		'República de Colombia',
		'Once de Noviembre',
		'Alberto Carvajal Borrero',
		'Abrahan Domínguez',
		'Juan De Ampudia',
		'Jardín Nacional No.1',
		'Marco Fidel Suarez',
		'Jardín Infantil Divino Salvador',
		'Republica del Perú',
		'Olga Lucia Lloreda',
		'República del Ecuador',
		'Técnica Industrial Antonio José Camacho',
		'Santa Librada- Sede Eustaquio Palacios',
		'General Alfredo Vásquez Cobo - Barrio Aranjuez',
		'Nuestra Señora De Los Remedios',
		'Sebastián de Belalcázar',
		'República de Argentina',
		'Policarpa Salavarrieta',
		'José Maria Córdoba',
		'Honorio Villegas',
		'Carlos Holguin Lloreda',
		'Republica de Costa Rica',
		'Jardín Infantil Nacional No. 2',
		'Santa Elena',
		'Joaquín De Cayzedo y Cuero',
		'San Roque',
		'General Carlos Albán',
		'Isabel de Castilla',
		'José Maria Vivas Balcázar',
		'Santo Domingo',
		'Rafael Navia Varon',
		'José Maria Carbonell',
		'Francisco Montes Idrobo',
		'Panamericana',
		'Normal Superior Santiago De Cali',
		'Joaquin Caycedo y Cuero',
		'Satélite Camilo Torres',
		'Fernando Velasco',
		'Susana Vinasco de Quintana',
		'La Independencia',
		'Boyacá',
		'Santo Domingo',
		'General Francisco De Paula Santander',
		'Agustín Nieto Caballero',
		'José Maria Vivas Balcázar',
		'José Vicente Concha',
		'El Recuerdo',
		'Diez de Mayo',
		'Centro Docente Republica de Italia',
		'General Alfredo Vásquez Cobo',
		'Comercial Ciudad de Cali',
		'Ciudad Modelo',
		'Villa del Sur',
		'Marino Rengifo Salcedo',
		'Antonio Ricaurte',
		'Leon XIII',
		'San Pedro Codenal',
		'Julio Arboleda',
		'Primavera',
		'Eva Riascos Plata',
		'Hernando Caicedo',
		'Asturias',
		'San Buenaventura',
		'Alfonso Barberena',
		'Fenalco Asturias',
		'Técnica Comercial Hernando Navia Varón',
		'Fray José Ignacio Ortiz',
		'Julio Caicedo y Téllez',
		'Batalla De Carabobo',
		'Francisco De Paula Santander',
		'Esther Zorrilla',
		'Mi Bosquesito',
		'Centro Docente Julio Rincón',
		'Ciudad de Cali',
		'Industrial Marice Sinisterra',
		'Centro Docente Juan XXIII',
		'Centro Docente Nino Jesús de Praga',
		'Bello Horizonte',
		'Enrique Olaya Herrera',
		'Juan Pablo II',
		'Centro Docente Rodrigo Lloreda Caicedo',
		'Santa Rosa Sede  I',
		'José Cardona Hoyos',
		'Humberto Jordán Mazuera',
		'El Diamante',
		'Bartolomé Loboguerrero',
		'Técnico Industrial Luz Haydee Guerrero',
		'Charco Azul',
		'Miguel Camacho Perea',
		'Villablanca',
		'Jesús Villafañe Franco',
		'Omaira Sánchez',
		'Gabriela Mistral',
		'Damaso Zapata',
		'Institución Educativa Nuevo Latir',
		'La Anunciación',
		'Elias Salazar Garcia',
		'Isaias Hernan Ibarra',
		'Monseñor Ramón Arcila',
		'Puertas Del Sol IV y V',
		'Raúl Silva Holguín',
		'Alfonso Reyes Echandía',
		'Puerta del Sol',
		'Los Naranjos',
		'Gabriel García Márquez',
		'Alfonso Bonilla Naar',
		'Carlos Holguín Mallarino',
		'José Ramón Bejarano',
		'Enrique Olaya Herrera',
		'Ciudad Córdoba',
		'Miguel de Pombo',
		'Niño Jesús de Atocha',
		'Cristóbal Colon - Barrio Mariano Ramos',
		'Bienestar Social',
		'Rodrigo Lloreda Caicedo',
		'Luis Enrique Montoya',
		'Micaela Castro Borrero',
		'José Joaquín Jaramillo',
		'Antonia Santos',
		'Carlos Holmes Trujillo',
		'Donald Rodrigo Tafur',
		'Francisco J. Ruiz',
		'Alejandro Montaño',
		'Libardo Madrid Valderrama',
		'Angélica Sierra Arizabaleta',
		'Pablo Neruda',
		'Primero de Mayo',
		'Lizandro Franky',
		'Cristo Maestro',
		'Policarpa Salavarrieta',
		'Antonio Nariño',
		'José Maria Carbonell',
		'Primitivo Crespo',
		'Técnico Industrial Comuna Diecisiete',
		'Luis Carlos Rojas Garcés',
		'General Santander',
		'Celimo Rueda',
		'Jhon F. Kennedy',
		'Buenos Aires',
		'Luis Eduardo Nieto Caballero',
		'Juan Pablo II',
		'Juan Pablo II, Sede Alvaro Escobar Nav',
		'Juan Pablo II, Sede Portete De Tarqui',
		'Álvaro Echeverry',
		'Rufino José Cuervo',
		'Juan Pablo II, Sede Templo Del Saber',
		'Magdalena Ortega de Nariño',
		'Eduardo Riascos Grueso',
		'La Esperanza',
		'Monseñor Luis Adriano Díaz',
		'Eustaquio Palacios',
		'General Anzoátegui',
		'Juana de Caicedo y Cuero',
		'Francisco José de Caldas',
		'Liceo Departamental',
		'La Presentación',
		'La Gran Colombia',
		'Los Cristales',
		'25 de Julio',
		'Politécnico Municipal de Cali',
		'Jorge Eliécer González Rubio',
		'Juana de Caicedo y Cuero Sede Simón Bolívar',
		'Luis López de Mesa',
		'Miguel Antonio Caro',
		'Manuel Maria Buenaventura',
		'Sofía Camargo de Lleras',
		'Fray Cristóbal de Torres',
		'Mariscal Jorge Robledo',
		'Celanese',
		'Juana de Caicedo y Cuero Sede Antonia Santos',
		'República de Panamá',
		'Luis Alberto Rosales',
		'Santiago Rengifo Salcedo',
		'Técnica Ciudadela Desepaz',
		'Cañasgordas',
		'Navarro (Juan Bautista De La Salle)',
		'Juan del Corral',
		'Antonio Villavicencio',
		'Tulia Borrero Mercado',
		'Pantano De Vargas',
		'Técnica De Ballet Clásico Incolballet',
		'Pance',
		'Pio XII',
		'República de Santo Domingo',
		'San Francisco',
		'Laureano Gómez',
		'La Buitrera José Maria García de Toledo',
		'Centro Docente Nuestra Señora de Las Lajas',
		'Centro Docente Los Comuneros',
		'Centro Docente Soledad Acosta de Samper',
		'Multipropósito',
		'Santa Luisa',
		'Nuestra Señora del Carmen',
		'Villacarmelo -Cacique Calarcá',
		'Francisco José de Caldas',
		'Juan Pablo I',
		'Tulio Enrique Tascón',
		'Tierra de Hombres',
		'José Holguín Garcés',
		'Centro Educativo Cantillo 171',
		'La Inmaculada Concepción',
		'La Leonera ITA Farallones',
		'Jorge Eliecer Gaitán - Barrio Vereda El Porvenir',
		'Juan de Los Barrios',
		'Satélite José Holguín Garcés',
		'República de Cuba',
		'Cristóbal Colón',
		'Francisco José Lloreda Mera',
		'Luis Fernando Lloreda Zamorano',
		'Francisco Miranda',
		'Boyacá',
		'Nueva San Francisco',
		'Ignacio Herrera y Vergara',
		'Sagrado Corazón',
		'La Granja',
		'La Paz- Saavedra Galindo',
		'Jorge Robledo',
		'Villa Del Rosario',
		'Montebello',
		'San Pedro Apóstol',
		'Andrés Joaquín Lenis',
		'Institución Educativa Golondrinas',
		'Antonio Barberena',
	]

	paises: string[] = [
		"Afganistán",
		"Albania",
		"Alemania",
		"Andorra",
		"Angola",
		"Antigua y Barbuda",
		"Arabia Saudita",
		"Argelia",
		"Argentina",
		"Armenia",
		"Australia",
		"Austria",
		"Azerbaiyán",
		"Bahamas",
		"Bangladés",
		"Barbados",
		"Baréin",
		"Bélgica",
		"Belice",
		"Benín",
		"Bielorrusia",
		"Birmania",
		"Bolivia",
		"Bosnia y Herzegovina",
		"Botsuana",
		"Brasil",
		"Brunéi",
		"Bulgaria",
		"Burkina Faso",
		"Burundi",
		"Bután",
		"Cabo Verde",
		"Camboya",
		"Camerún",
		"Canadá",
		"Catar",
		"Chad",
		"Chile",
		"China",
		"Chipre",
		"Ciudad del Vaticano",
		"Colombia",
		"Comoras",
		"Corea del Norte",
		"Corea del Sur",
		"Costa de Marfil",
		"Costa Rica",
		"Croacia",
		"Cuba",
		"Dinamarca",
		"Dominica",
		"Ecuador",
		"Egipto",
		"El Salvador",
		"Emiratos Árabes Unidos",
		"Eritrea",
		"Eslovaquia",
		"Eslovenia",
		"España",
		"Estados Unidos",
		"Estonia",
		"Etiopía",
		"Filipinas",
		"Finlandia",
		"Fiyi",
		"Francia",
		"Gabón",
		"Gambia",
		"Georgia",
		"Ghana",
		"Granada",
		"Grecia",
		"Guatemala",
		"Guyana",
		"Guinea",
		"Guinea ecuatorial",
		"Guinea-Bisáu",
		"Haití",
		"Honduras",
		"Hungría",
		"India",
		"Indonesia",
		"Irak",
		"Irán",
		"Irlanda",
		"Islandia",
		"Islas Marshall",
		"Islas Salomón",
		"Israel",
		"Italia",
		"Jamaica",
		"Japón",
		"Jordania",
		"Kazajistán",
		"Kenia",
		"Kirguistán",
		"Kiribati",
		"Kuwait",
		"Laos",
		"Lesoto",
		"Letonia",
		"Líbano",
		"Liberia",
		"Libia",
		"Liechtenstein",
		"Lituania",
		"Luxemburgo",
		"Madagascar",
		"Malasia",
		"Malaui",
		"Maldivas",
		"Malí",
		"Malta",
		"Marruecos",
		"Mauricio",
		"Mauritania",
		"México",
		"Micronesia",
		"Moldavia",
		"Mónaco",
		"Mongolia",
		"Montenegro",
		"Mozambique",
		"Namibia",
		"Nauru",
		"Nepal",
		"Nicaragua",
		"Níger",
		"Nigeria",
		"Noruega",
		"Nueva Zelanda",
		"Omán",
		"Países Bajos",
		"Pakistán",
		"Palaos",
		"Panamá",
		"Papúa Nueva Guinea",
		"Paraguay",
		"Perú",
		"Polonia",
		"Portugal",
		"Reino Unido",
		"República Centroafricana",
		"República Checa",
		"República de Macedonia",
		"República del Congo",
		"República Democrática del Congo",
		"República Dominicana",
		"República Sudafricana",
		"Ruanda",
		"Rumanía",
		"Rusia",
		"Samoa",
		"San Cristóbal y Nieves",
		"San Marino",
		"San Vicente y las Granadinas",
		"Santa Lucía",
		"Santo Tomé y Príncipe",
		"Senegal",
		"Serbia",
		"Seychelles",
		"Sierra Leona",
		"Singapur",
		"Siria",
		"Somalia",
		"Sri Lanka",
		"Suazilandia",
		"Sudán",
		"Sudán del Sur",
		"Suecia",
		"Suiza",
		"Surinam",
		"Tailandia",
		"Tanzania",
		"Tayikistán",
		"Timor Oriental",
		"Togo",
		"Tonga",
		"Trinidad y Tobago",
		"Túnez",
		"Turkmenistán",
		"Turquía",
		"Tuvalu",
		"Ucrania",
		"Uganda",
		"Uruguay",
		"Uzbekistán",
		"Vanuatu",
		"Venezuela",
		"Vietnam",
		"Yemen",
		"Yibuti",
		"Zambia",
		"Zimbabue"
	]



	constructor() { }


}
